<template>
  <!-- <div class="expand-customer is-clickable" v-show="!showExpandCust" @click="showExpandCust = !showExpandCust">
    show cust panel
  </div> -->
  <div class="column is-fullheight is-flex is-flex-direction-column is-align-items-stretch p-0 no-flow-y">
    <div class="is-flex is-flex-direction-row is-flex-grow-1 no-flow-y">
      <div class="is-one-fifth column has-background-light is-flex is-flex-direction-column side-panel" style="width: 20%; max-width: 20%; flex-shrink: 0;" v-bind:class="{'is-hidden':!showExpandCust}">
        <!-- <div class="cust-controll is-flex is-flex-drirection-row is-justify-content-space-around pb-2">
          <div>
            <a class="button mr-2" id="custinfo" @click="custInfoControl"> Cust Info</a>
          </div>
          <div>
            <a class="button" id="newcust" @click="custInfoControl"> New Cust</a>
          </div>
          <div class="pl-2">

            <input type="checkbox"  v-model="load3month" @click="setLocalLoad3month">
            <i> P </i>

          </div>
        </div> -->
        <div class="column cust_create_wrapper p-0" v-bind:class="{'is-hidden':!showCreateCust}" style="max-height: 100%; overflow-y: auto;">
          <div class="column is-flex pl-0 pr-0 pt-1 pb-1 cust_focus_info_title is-flex-grow-0 has-background-warning" style="max-width: 100%;">
            <div class="column has-text-left p-0 pl-2" style="width:100%">
              <p> <strong>CUSTOMER_CREATE</strong></p>
            </div>
            <div class="column has-text-right pt-0 pb-0">
              <i class="fa-solid fa-xmark is-clickable has-text-danger" @click="showCreateCust = false"> </i>
            </div>
          </div>
          <form @submit.prevent="submitForm" class="mt-2">
            <div class="field">
              <label class="label">Customer Phone</label>
              <div class="control">
                <input class="input" type="text" placeholder="customer_phone" id='createCust_cust_phone' autocomplete="nofill" @change="formPhoneChangeCreateForm">
              </div>
            </div>
            <div class="field">
              <label class="label">Customer Name</label>
              <div class="control">
                <textarea class="input" type="text" placeholder="customer_name" id='createCust_cust_name' autocomplete="nofill" style="resize: none;"></textarea>
              </div>
            </div>
            <div class="field">
              <label class="label">Email</label>
              <div class="control">
                <textarea class="input" type="text"  placeholder="email" id="createCust_cust_email" autocomplete="nofill"  style="resize: none;">na@na.com</textarea>
              </div>
            </div>
            <div class="field">
              <label class="label">Address</label>
              <div class="control">
                <textarea class="input" style="height: 4rem;" type="text" id='createCust_cust_address' placeholder="customer_address"
                @change="formAddChangeCreateForm"  
                > </textarea>
              </div>
            </div>
            <div class="field">
              <label class="label">District</label>
              <div class="control">
                <!-- <textarea class="input text-black" style="resize: none" type="text" id='createCust_cust_address_district' placeholder="district" v-bind:disabled="!this.isPlaningCS"> </textarea> -->
                <select name="district" id="createCust_cust_address_district" class="input" v-model="selectedDistrict_create_cust" disabled>
                <option value="na">na</option>
                <option v-for="( key) in districts" :key="key" v-bind:value="key">
                  {{ key }}
                </option>
              </select>
              </div>
            </div>
            <div class="field">
              <label class="label">Ward</label>
              <div class="control">
                <select name="district" id="createCust_cust_address_ward" class="input" v-model="selectedWard_create_cust" disabled>
                  <option value="na">na</option>
                  <option v-for="( key) in wards_selected_district_create_cust" :key="key" v-bind:value="key">
                    {{ key }}
                  </option>
                </select>
                <!-- <textarea class="input text-black" style="resize: none" type="text" id='createCust_cust_address_ward' placeholder="ward" v-bind:disabled="!this.isPlaningCS"> </textarea> -->
              </div>
      
            </div>
            <!-- Ship Loc is hidden: it is no longer picked or displayed here. On submit
                 ship_dis_str is derived from the selected New Ward (see shipDisFromNewWard). -->
            <div class="field" v-if="false">
              <label class="label">Ship Loc</label>
              <div class="control">
              <div class="select is-fullwidth">
                <select id="createCust_cust_address_ship_dis" style=" overflow-y: auto;" v-model="selectedShipDis_create_cust" disabled>
                  <option value="na">na</option>
                  <option v-for="(item, key) in ship_dis" :key="key" v-bind:value="item.shipDis">
                    {{ item.shipDis }} - {{ Math.floor(item.price / 5).toLocaleString() + ' đ/ngày' }}
                  </option>
                </select>
              </div>
            </div>
              <!-- <div class="control">
                <textarea class="input text-black" style="resize: none" type="text" id='createCust_cust_address_ship_dis' placeholder="district" v-bind:disabled="!this.isPlaningCS"> </textarea>
              </div> -->
            </div>
            
            <div class="field">
              <label class="label">New Ward</label>
              <div class="control">
                <v-autocomplete
                  ref="newWardAutoCreateCust"
                  v-model="selectedNewWard_create_cust"
                  :items="newWardOptions"
                  item-title="title"
                  item-value="value"
                  :custom-filter="newWardFilter"
                  density="compact"
                  variant="outlined"
                  hide-details
                  auto-select-first
                  placeholder="Type to search new ward…"
                  @update:model-value="onNewWardChange_create_cust"
                ></v-autocomplete>
              </div>
            </div>
            <div class="field">
              <div class="control">
                <div class="column" v-if="createCustFormErrors.length">
                  <div class="notification is-danger"  >
                    <p v-for="error in createCustFormErrors" v-bind:key="createCustFormErrors"> {{ error }}</p>
                  </div>
                </div>
                <!-- <button class="button is-primary" @click="submitFormLogin">Login</button> -->
                <div class="is-flex is-justify-content-end">
                  <button class="button is-warning" @click="submitFormCreateCust"> CREATE CUSTOMER </button>
                </div>
                
              </div>
            </div>
          </form>
        </div>
        <div class="column cust_focus_info_wrapper p-0" v-bind:class="{'is-hidden':showCreateCust}">
          <div class="is-flex pl-0 pr-0 pt-1 pb-1 is-flex-direction-row is-flex pb-0.5 cust_focus_info_title has-background-warning">
            <div class="is-flex pl-2" style="width:100%">
              <div> <p> <strong>CUSTOMER_INFO</strong></p> </div>
              <div class="pl-2 is-clickable" id="newcust" @click="custInfoControl"> <p> <strong><i class="fa-solid fa-plus  is-clickable is-size-6"></i> </strong></p> </div>
              <div class="pl-2 is-flex is-flex-direction-row is-justify-content-flex-end is-flex-grow-3">
                <input type="checkbox" class="mr-2"  v-model="load3month" @click="setLocalLoad3month" title="chỉ load 3 tháng gần nhất">
                <i> P </i>
              </div>
              <!-- <div>
                <i class="fa-solid fa-angles-left pl-3 is-clickable" @click="showExpandCust = !showExpandCust"></i>
              </div> -->
            </div>
            <div class="column has-text-right pt-0 pb-0">
            </div>
          </div>

          <div class="field mb-0 mt-2">

            <div class="control">
              <i class="fa-solid fa-xmark custinfo_cust_phone-remove autocomplete" v-bind:class="{'is-hidden':!hasValueCustInfo}" @click="removeCurrentCustInfoValue"></i>
              <input 
                class="input autocomplete" type="text" placeholder="customer phone" id='custinfo_cust_phone' autocomplete="off" 
                @change="formPhoneChange" 
                v-model="autocompleteValue"
                @input="custInfoInput"
                @focusin="custInfoInput"
                v-on:keydown="custInfoKeyDown"
                >
              <ul
                v-show="isOpenAutocomplete"
                class="autocomplete-results-holder autocomplete"
              >
              <!-- v-show="isOpenAutocomplete" -->
                <li
                  v-for="(result, i) in autocompleteSuggestionsShow"
                  class="autocomplete-result pl-2 pt-2 is-size-5 autocomplete"
                  @click="clickAutocomplete"
                  :class="[(i === arrowCounter) ? 'is-active' : '' , i+'-autocomplete-stt']"
                >
                {{ result }}
                </li>
              </ul>
                <!-- @update:search="(modelValue) => testChange(modelValue)" -->
            </div>
          </div>
          <div class="column group_main_info">
            
            <div class="column p-0">
              <i class="fa-solid fa-copy is-clickable" @click="copyCustInfo"></i>
              <span> <strong> Name: </strong>  </span>
              <span class="group_main_info_name" v-bind:innerHTML="this.custName">
              </span>
            </div>
            <div class="column p-0">
              <span> <strong> Main Address: </strong>  </span>
              <span class="group_main_info_address" v-text="this.custMainAddress">
              </span>
            </div>
            <div class="column p-0">
              <span> <strong> Main Phone: </strong>  </span>
              <span class="group_main_info_phone" v-text="this.custMainPhone">
              </span>
            </div>
            <div class="column p-0">
              <span> <strong> Diet: </strong>  </span>
              <span class="group_main_info_phone" v-bind:innerHTML="this.diets"> 
              </span>
            </div>
            <div class="column p-0">
              <span> <strong> Traits: </strong>  </span>
              <span class="group_main_info_phone" v-bind:innerHTML="this.traits"> 
              </span>
            </div>
          </div>
          <!-- start of other ADDRESS -->
          <div class="field mb-2 mt-2 group_address_title has-background-warning" >
            <div class="column has-text-left pt-1 pl-0 pr-0 pb-1 pl-2 is-flex is-flex-direction-row">
              <strong class="is-flex-grow-3">OTHER ADDRESS
                <i v-if="custId" class="fa-solid fa-plus pl-2 is-clickable is-size-6"
                @click="showCreateAddress = !showCreateAddress"
                ></i>
              </strong>
              
              <i class="is-clickable pr-2"
              v-bind:class="[!(this.addressShowAll) ? 'is-hidden' : '']"
              @click="this.addressShowAll = false"
              > showing all</i>

              <i class="is-clickable pr-2"
              v-bind:class="[(this.addressShowAll) ? 'is-hidden' : '']"
              @click="this.addressShowAll = true"
              > showing active</i>

            </div>
          </div>

          <div class="column pl-0 pr-0 pt-0 pb-0 group_address" >
            <v-card class="table-container table-address-height pb-0" >
              <v-data-table-virtual
                id="table-group-address"
                class="table-address-height"
                :headers="headersAddress"
                :items="group_address_filtered"
                fixed-header
                sortable: false
                items-per-page="1000"
                width="100%"
              >
              
              <template  #item="{ item }">
                <tr >
                  <td class="hide-add-item" v-bind:class="[
                    (item.is_main) ? 'is-hidden' : '',
                    (item.is_active) ? 'ia-active' : '',
                    (this.addressShowAll) ? 'show-active' : ''
                  ]">
                    <span class=""> {{item.name}}  </span>   
                    <i class="fa-solid pl-2 fa-eject custAdd-control makemain pt-1" 
                      v-bind:id="[item.id+'-cust-address-item']" 
                      v-bind:class="[(!(item.is_main) && item.is_active) ? 'is-clickable' :'is-disabled' ]"
                      @click="custAddressEdit"></i>

                    <i class="fa-regular fa-rectangle-xmark pl-2 custAdd-control deactive pt-1" 
                      v-bind:class="[!(item.is_active) ? 'is-disabled' : 'is-clickable']" 
                      v-bind:id="[item.id+'-cust-address-item']" 
                      @click="custAddressEdit"></i>

                    <i class="fa-regular fa-square-check pl-2 custAdd-control activate pt-1" 
                      v-bind:class="[(item.is_active) ? 'is-disabled' : 'is-clickable']" 
                      v-bind:id="[item.id+'-cust-address-item']" 
                      @click="custAddressEdit"></i> 
                    
                    
                    <br>
                    <span class=""> {{item.phone_number_readable}}  </span> <br>
                    <span class=""> <strong> address: </strong> {{item.address_detail}} </span> <br>
                    <span class=""> <strong> new_ward: </strong> {{ item.new_ward_str }} </span> <br>
                    <span class=""> <strong> district: </strong> {{ item.district_str }} </span> <br>
                    <span class=""> <strong> ward: </strong> {{ item.ward_str }} </span> <br></br>
                  </td>
                </tr>
              </template >

              </v-data-table-virtual>

            </v-card>

          </div>
          <!-- end of customer address -->
        
        </div>
      </div>
      <div class="is-three-fifths is-flex column is-flex-grow-1 pb-0 pr-1" style="min-width: 0; overflow: hidden;">
        <div class="is-flex is-flex-direction-column is-flex-grow-1 min-h-0" style="max-width: 100% !important">
          <div class="history-holder is-flex-grow-2 mb-1">
              <div class="week-holder template-week is-hidden" style="max-height: 100%;">
                  <div class="week-holder-title is-size-5 has-text-centered is-clickable is-flex is-flex-direction-row" style="display: inline-block;"> Week: <strong class="weekStr"> Template </strong>
                  </div>
                  <div class="week-holder-inner" style="max-height: 100%;">
                    <div class="orderpacks-holder is-flex-grow-1 template-package">
                      <div class="orderpack-detail">
                        <div class="orderpack-detail-title is-clickable" >
                          <div class="orderpack-detail-title-line">
                            <strong class="pack-id"> 3334 </strong>
                            <i>/</i>
                            <strong class="pack-alias"> FIT1 </strong>
                            <i>/</i>
                             <strong class="totalMeals"> </strong><strong>meals</strong>
                            <i>/</i>
                            <strong class="shipLoc"> Quận 8 </strong>
                          </div>
                        </div>
                        <div class="orderpack-detail-contents is-flex is-flex-direction-row is-clickable" >
                          <div class="mon" >
                            <i>mon<br></i>
                            <i> SA:<strong class="SA"></strong><br></i>
                            <i> TR:<strong class="TR"></strong><br></i>
                            <i> TO:<strong class="TO"></strong><br></i>
                            <i> KH:<strong class="O"></strong><br></i>
                          </div>
                          <div class="tue">
                            <i>tue<br></i>
                            <i> SA:<strong class="SA"></strong><br></i>
                            <i> TR:<strong class="TR"></strong><br></i>
                            <i> TO:<strong class="TO"></strong><br></i>
                            <i> KH:<strong class="O"></strong><br></i>
                          </div>
                          <div class="wed">
                            <i>wed<br></i>
                            <i> SA:<strong class="SA"></strong><br></i>
                            <i> TR:<strong class="TR"></strong><br></i>
                            <i> TO:<strong class="TO"></strong><br></i>
                            <i> KH:<strong class="O"></strong><br></i>
                          </div>
                          <div class="thu">
                            <i>thurs<br></i>
                            <i> SA:<strong class="SA"></strong><br></i>
                            <i> TR:<strong class="TR"></strong><br></i>
                            <i> TO:<strong class="TO"></strong><br></i>
                            <i> KH:<strong class="O"></strong><br></i>
                          </div>
                          <div class="fri">
                            <i>fri<br></i>
                            <i> SA:<strong class="SA"></strong><br></i>
                            <i> TR:<strong class="TR"></strong><br></i>
                            <i> TO:<strong class="TO"></strong><br></i>
                            <i> KH:<strong class="O"></strong><br></i>
                          </div>
                        </div>
                        <div class="orderpack-detail-title-after is-clickable" >
                          <div class="orderpack-detail-title-after-line-1">
                            <i class="noteDBArrText is-lowercase">KO CÀ CHUA BI</i>
                          </div>
                          <div class="orderpack-detail-title-after-line has-text-right">
                            <i class="idStr"> 17657-19578|MQBHP0 </i>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
              </div>
              <div class="week-holder time-holder is-hidden" style="max-height: 100%;">
                  <div class="week-holder-title is-size-5 has-text-centered is-flex is-flex-direction-row" style="display: inline-block;"> <i> <strong class="numweek"> </strong>  weeks </i>
                  </div>
              </div>
          </div>
          <div class="is-flex is-flex-direction-row is-flex-grow-5 min-h-0 is-justify-content-flex-end" >
            <div class="detail-holder-info is-align-items-stretch is-flex-grow-4">
              <div class="detail-holder-info-controller is-flex is-flex-direction-row">
                <div class="pr-3 pl-2 control-item is-clickable is-active" @click="showControl" id="orderList"> Order List  </div>
                <div class="pr-3  pl-2 control-item is-clickable " @click="showControl" id="info"> Info  </div>
                <div class=" pr-2 control-item is-clickable pl-2" @click="showControl" id="details"> Details  </div>
                <div class="pr-3 pl-2 control-item is-clickable " @click="showControl" id="customerBalance"> Customer Balance  </div>
              </div>
              <div class="has-background-light detail-holder-order-list is-flex is-flex-direction-row is-flex-grow-1 is-align-items-stretch orderList-control-class is-active" style="width: 100%;">
                <div class="detail-holder-order-list-part-1 pl-2 pt-2 is-flex-grow-1 is-flex is-flex-direction-column pb-3" style="overflow: hidden; max-width: 100%;">
                  <div class="is-flex is-flex-direction-row is-justify-content-space-between pb-1" style="width:100%;">
                    <div class="is-flex is-flex-direction-row" style="overflow-x: hidden; max-width: 19vw;">
                      <strong class="is-size-5">Danh sách order của khách</strong>
                    </div>
                    <div class="is-flex-grow-1 pl-3" style="overflow-x: hidden; max-width: 19vw;">
                      <div>
                        <button class="button" v-bind:disabled="!(this.selectedforInBill.length>0)" @click="clearSelectedInBill"> clear </button>
                        <button class="button ml-2" v-bind:disabled="!(this.selectedforInBill.length>0)" @click="sendInBill"> Bill Chi Tiết </button>
                      </div>
                    </div>
                    <div class="field has-addons" style="overflow-x: hidden; max-width: 19vw;">
                      <div class="control ">
                        <a class="button is-static">
                          <i class="fa-solid fa-reply-all is-clickable" aria-hidden="true" @click="deFilterOrderList"></i>
                        </a>
                      </div> 
                      <div class="control">
                        <input class="input de-filter-order-list" type="text" placeholder="Search complete input" v-model="search">
                      </div>
                      <div class="control">
                        <a class="button is-static">
                          <i class="fa fa-search" aria-hidden="true"></i>
                        </a>
                      </div>
                      
                    </div>
                  </div>
                  <div class="is-flex is-flex-direction-row is-flex-grow-1 min-h-0 pr-2">
                    <v-card class="table-container is-flex-grow-1 table-main-order-list-height"  >
                      <v-data-table-virtual
                        id="table-main-order-list"
                        class="table-main-order-list-height"
                        :headers="headers"
                        :items="orders"
                        :search="search"
                        :custom-filter="customSearch"
                        fixed-header
                        sortable: false
                        items-per-page="1000"
                        width="100%"
                      >
                        <template   #item="{ item }" >
                          
                          <tr v-bind:id="[item.id+'-order-list']" class="row-order-list "  
                          v-bind:class="[ (item.id === this.selectedPackId) ? 'is-active' : '']">
                            <td> 
                              <input type="checkbox" v-model="selectedforInBill" :value="item.id" @change="testMulti">
                            </td>
                            <td class="is-clickable" @click="clickRowOrderList"> {{ item.week_str }}</td>
                            <td class="is-clickable" @click="clickRowOrderList"> {{ item.packageLocalId }}</td>
                            <td class="is-clickable" @click="clickRowOrderList"> {{ 
                            (item.ycdb2 === 'Thêm phần ăn sáng dành cho gói MEAT LOVER') ? item.packAlias.replace('MEAT', 'MEAT-S') : item.packAlias }}</td>
                            <td class="is-clickable" @click="clickRowOrderList"> {{ (item.shipLoc.indexOf('(') >-1) ? item.shipLoc.slice(0,item.shipLoc.indexOf('(')) : item.shipLoc}}</td>
                            <td class="has-text-right is-clickable" @click="clickRowOrderList"> {{ this.formatPriceRound( item.finalAmt ) }}</td>
                            <td class="is-clickable" @click="clickRowOrderList"> {{ item.customerNote }}</td>
                          </tr>
                        </template >

                      </v-data-table-virtual>

                    </v-card>
                  </div>
                  
                </div>
              </div>
              <div class="has-background-light detail-holder-info-order-info is-flex is-flex-direction-row info-control-class">
                <div class="order-info-part-1 pl-2 pt-2 is-flex-grow-5 is-flex is-flex-direction-column pb-3" style="max-width: 60%;">
                  <div class="mb-1"> <strong> Thông tin gói ăn</strong>  </div>
                  <div class="is-flex is-flex-direction-column"> 
                    <div class="order-info-item-line is-flex is-flex-direction-row">
                      <div class="custText-preText"> Pack: </div> <div class="custText"><strong class="packAlias-pack-info to-reset-inner-html"></strong> 
                        / <strong class="week_str-pack-info to-reset-inner-html"></strong>
                        : <strong class="packageLocalId-pack-info to-reset-inner-html"></strong>  
                        / <strong class="totalMeals-pack-info to-reset-inner-html"></strong> <strong>meals</strong>  </div>
                    </div>
                  </div>
                  <div>
                    <div class="mb-1"> <strong> Yêu cầu món ăn</strong>  </div>
                    <div class="order-info-item-line is-flex is-flex-direction-row">
                      <div class="custText-preText"> ycdb: </div> <div class="custText"><i class="ycdb-pack-info to-reset-inner-html"></i></div>
                    </div>
                    <div class="order-info-item-line is-flex is-flex-direction-row">
                      <div class="custText-preText"> ycdb2: </div> <div class="custText"><i class="ycdb2-pack-info to-reset-inner-html"></i></div>
                    </div>
                    <div class="order-info-item-line is-flex is-flex-direction-row">
                      <div class="custText-preText is-flex is-flex-direction-row nowrap nowrap-toogle" > Ghi Chú Phần Ăn: </div> <div class="custText"><i class="customerNote-pack-info to-reset-inner-html"></i></div>
                    </div>
                  </div>
                  <div>
                    <div class="mb-1"> <strong> Yêu cầu ship </strong>  </div>
                    <div class="order-info-item-line is-flex is-flex-direction-row">
                      <div class="custText-preText"> shipLoc: </div> <div class="custText"><i class="shipLoc-pack-info to-reset-inner-html"></i></div>
                    </div>
                    <div class="order-info-item-line is-flex is-flex-direction-row">
                      <div class="custText-preText"> Address: </div> <div class="custText"><i class="address-pack-info to-reset-inner-html"></i></div>
                    </div>
                    <div class="order-info-item-line is-flex is-flex-direction-row">
                      <div class="custText-preText nowrap nowrap-toogle" > Note 2 hàng tuần: </div> <div class="custText"><i class="noteShipThisWeek-pack-info to-reset-inner-html"></i></div>
                    </div>
                    <div class="order-info-item-line is-flex is-flex-direction-row">
                      <div class="custText-preText nowrap nowrap-toogle" > Note 1 cố định: </div> <div class="custText"><i class="noteShipping-pack-info to-reset-inner-html"></i></div>
                    </div>
                  </div>
                </div>
                <div class="order-info-invoice pl-2 pt-2 is-flex-grow-1">
                  <div class="mb-1"> <strong> Chi Tiết Thành Tiền </strong>  </div>
                  <div class="is-flex is-flex-direction-column price-holder">
                    <div class="order-info-item-line is-flex is-flex-direction-row">
                      <div class="custPrice-preText name-cust-price"> 
                        <div class="pr-1">Khách hàng:</div> <strong class="customerName-pack-price to-reset-inner-html pr-1"> </strong> 
                        (tuần <strong class="week_str-pack-price to-reset-inner-html"> </strong>)
                      </div> 
                    </div>
                    <div class="order-info-item-line is-flex is-flex-direction-row">
                      <div class="custPrice-preText"> 
                        <strong class="packAlias-pack-price pr-1"></strong> ( <div class="totalMeals-pack-price to-reset-inner-html"></div>meals) 
                      </div> 
                      <div class="custPrice"><div class="packAmt-pack-price to-reset-inner-html"></div></div>
                    </div>
                    <div class="order-info-item-line is-flex is-flex-direction-row specialAmt-adj is-hidden">
                      <div class="custPrice-preText"> <p> Phí dịch vụ ycdb :</p>   </div> <div class="custPrice"><div class="specialAmt-pack-price to-reset-inner-html"></div></div>
                    </div>
                    <div class="order-info-item-line is-flex is-flex-direction-row otherAmt-adj is-hidden">
                      <div class="custPrice-preText"> <div class="otherDesc-pack-price" disabled>  </div> </div> <div class="custPrice"><div class="otherAmt-pack-price"></div></div>
                    </div>
                    <div class="order-info-item-line is-flex is-flex-direction-row side-order-details is-hidden">
                      <div class="custPrice-preText"> <div class="side-order-name" disabled> SIDE </div> 
                        ( <div class="side-order-quant" disabled> </div>  x) 
                      </div> 
                      <div class="custPrice"><div class="side-order-price"></div>
                      </div>
                    </div>
                    <div class="order-info-item-line is-flex is-flex-direction-row side-order-details-adj is-hidden">
                      <div class="custPrice-preText"> <div class="side-order-name" disabled> Điều chỉnh giá sản phẩm phụ </div> </div> <div class="custPrice"><div class="side-order-price"></div></div>
                    </div>
                    <div class="order-info-item-line is-flex is-flex-direction-row ship-price-details-adj is-hidden">
                      <div class="custPrice-preText"> <div class="shipLoc-ship-item" disabled> Điều chỉnh giá ship </div> </div> <div class="custPrice"><div class="ship-price-ship-item"></div></div>
                    </div>
                    <div class="order-info-item-line is-flex is-flex-direction-row ship-details-this-order is-hidden">
                      <div class="custPrice-preText"> <div disabled class="pr-1"> Ship </div>  <div class="shipLoc-ship-item pr-1" disabled> </div> (<div class="shipLoc-quant-ship-item" disabled> </div> days)  </div> 
                      <div class="custPrice"><div class="ship-price-ship-item"></div></div>
                    </div>
                    <div class="order-info-item-line is-flex is-flex-direction-row ship-details-not-this-order is-hidden">
                      <div class="custPrice-preText"> <div disabled class="pr-1"> Ship </div>  <div class="shipLoc-ship-item pr-1" disabled> </div> (<div class="shipLoc-quant-ship-item" disabled> </div> days) (theo ID: <div class="packageLocalId-ship-item" disabled> </div>)  </div> 
                      <div class="custPrice"><div class="ship-price-ship-item"></div></div>
                    </div>
                    <div class="line-break mb-1">
                    </div>
                    <div class="order-info-item-line is-flex is-flex-direction-row">
                      <div class="custPrice-preText"> <p> Tổng giá:</p>   </div> <div class="custPrice"><div class="totalBeforeDiscount-pack-price to-reset-inner-html"></div></div>
                    </div>
                    <div class="order-info-item-line is-flex is-flex-direction-row">
                      <div class="custPrice-preText"> <p class="pr-1"> Discount:</p>  <div class="discountCode-pack-price"></div> </div> <div class="custPrice"><div class="discountAmt-pack-price to-reset-inner-html"></div></div>
                    </div>
                    <div class="line-break-2 mb-1">
                    </div>
                    <div class="order-info-item-line is-flex is-flex-direction-row">
                      <div class="custPrice-preText"> <p> Thành tiền:</p>   </div> <div class="custPrice"><div class="finalAmt-pack-price to-reset-inner-html"></div></div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- hidden -->
              <div class="has-background-light detail-holder-with-ship is-flex is-flex-direction-row is-flex-grow-1 is-align-items-stretch details-control-class" style="width: 100%;">
                <div class="is-flex is-flex-direction-column is-align-items-stretch p-2 is-flex-grow-1" >
                  <div class="has-background-light is-flex is-flex-direction-row"> 
                    <div class="is-size-5">
                      <strong>Thông tin chi tiết các package trong tuần</strong> <strong v-bind:innerHTML="quickWeekStr"> </strong>
                    </div>
                  </div>
                  <div class="details-with-ship-holder is-flex is-flex-direction-row is-align-items-stretch">
                    <div class="pack-table-holder is-flex is-flex-direction-column is-align-items-stretch is-flex-grow-1">
                      <div  class="pack-table-tbody template-package-table is-flex is-flex-direction-row is-align-items-stretch is-hidden">
                        <div class="pack-table-title is-flex is-flex-direction-column is-align-items-stretch">
                          <div class="is-flex-grow-2">
                          </div>
                          <div class="is-flex-grow-1 id-pack-table pl-2 has-text-weight-bold"> 
                          </div>
                          <div class="is-flex-grow-1 packageLocalId-pack-table pl-2 has-text-weight-bold"> 
                          </div>
                          <div class="is-flex-grow-2">
                          </div>
                        </div>
                        <div class="pack-table-details" >
                          <div class="pack-table-details-title is-flex is-flex-direction-row is-align-items-stretch is-flex-grow-1" >
                            <div class="pack-table-cell"></div>
                            <div class="pack-table-cell-2"><strong>mon</strong></div>
                            <div class="pack-table-cell-2"><strong>tue</strong></div>
                            <div class="pack-table-cell-2"><strong>wed</strong></div>
                            <div class="pack-table-cell-2"><strong>thurs</strong></div>
                            <div class="pack-table-cell-2"><strong>fri</strong></div>
                          </div>
                          <div class="pack-table-SA is-flex is-flex-direction-row is-align-items-stretch is-flex-grow-1">
                            <div class="pack-table-cell">SA</div>
                            <div class="day-2 pack-table-cell-2 day-2"></div>
                            <div class="day-3 pack-table-cell-2 day-3"></div>
                            <div class="day-4 pack-table-cell-2 day-4"></div>
                            <div class="day-5 pack-table-cell-2 day-5"></div>
                            <div class="day-6 pack-table-cell-2 day-6"></div>
                          </div>
                          <div class="pack-table-TR is-flex is-flex-direction-row is-align-items-stretch is-flex-grow-1">
                            <div class="pack-table-cell">TR</div>
                            <div class="day-2 pack-table-cell-2 day-2"></div>
                            <div class="day-3 pack-table-cell-2 day-3"></div>
                            <div class="day-4 pack-table-cell-2 day-4"></div>
                            <div class="day-5 pack-table-cell-2 day-5"></div>
                            <div class="day-6 pack-table-cell-2 day-6"></div>
                          </div>
                          <div class="pack-table-TO is-flex is-flex-direction-row is-align-items-stretch is-flex-grow-1">
                            <div class="pack-table-cell">TO</div>
                            <div class="day-2 pack-table-cell-2 day-2"></div>
                            <div class="day-3 pack-table-cell-2 day-3"></div>
                            <div class="day-4 pack-table-cell-2 day-4"></div>
                            <div class="day-5 pack-table-cell-2 day-5"></div>
                            <div class="day-6 pack-table-cell-2 day-6"></div>
                          </div>
                          <div class="pack-table-O is-flex is-flex-direction-row is-align-items-stretch is-flex-grow-1">
                            <div class="pack-table-cell">KH</div>
                            <div class="day-2 pack-table-cell-2 day-2"></div>
                            <div class="day-3 pack-table-cell-2 day-3"></div>
                            <div class="day-4 pack-table-cell-2 day-4"></div>
                            <div class="day-5 pack-table-cell-2 day-5"></div>
                            <div class="day-6 pack-table-cell-2 day-6"></div>
                          </div>
                          <div class="pack-table-shipDis is-flex is-flex-direction-row is-align-items-stretch is-flex-grow-1">
                            <div class="pack-table-cell">shipLoc</div>
                            <div class="day-2 pack-table-cell-2 day-2"></div>
                            <div class="day-3 pack-table-cell-2 day-3"></div>
                            <div class="day-4 pack-table-cell-2 day-4"></div>
                            <div class="day-5 pack-table-cell-2 day-5"></div>
                            <div class="day-6 pack-table-cell-2 day-6"></div>
                          </div>
                          <div class="pack-table-deliverTimeslot is-flex is-flex-direction-row is-align-items-stretch is-flex-grow-1">
                            <div class="pack-table-cell">time</div>
                            <div class="day-2 pack-table-cell-2 day-2"></div>
                            <div class="day-3 pack-table-cell-2 day-3"></div>
                            <div class="day-4 pack-table-cell-2 day-4"></div>
                            <div class="day-5 pack-table-cell-2 day-5"></div>
                            <div class="day-6 pack-table-cell-2 day-6"></div>
                          </div>
                          <div class="pack-table-shipper is-flex is-flex-direction-row is-align-items-stretch is-flex-grow-1">
                            <div class="pack-table-cell">shipper</div>
                            <div class="day-2 pack-table-cell-2 day-2"></div>
                            <div class="day-3 pack-table-cell-2 day-3"></div>
                            <div class="day-4 pack-table-cell-2 day-4"></div>
                            <div class="day-5 pack-table-cell-2 day-5"></div>
                            <div class="day-6 pack-table-cell-2 day-6"></div>
                          </div>
                          <div class="pack-table-address is-flex is-flex-direction-row is-align-items-stretch is-flex-grow-1">
                            <div class="pack-table-cell">address</div>
                            <div class="day-2 pack-table-cell-2 day-2"></div>
                            <div class="day-3 pack-table-cell-2 day-3"></div>
                            <div class="day-4 pack-table-cell-2 day-4"></div>
                            <div class="day-5 pack-table-cell-2 day-5"></div>
                            <div class="day-6 pack-table-cell-2 day-6"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="has-background-light detail-holder-customer-balance is-flex is-flex-direction-row is-flex-grow-1 is-align-items-stretch customerBalance-control-class" style="width: 100%;">
                <div class="detail-holder-transaction-part-1 pl-2 pt-2 is-flex-grow-1 is-flex is-flex-direction-column pb-3" style="overflow: hidden; max-width: 100%;">
                  <div class="is-flex is-flex-direction-row is-justify-content-space-between pb-2" style="width:100%">
                    <div>
                      <strong class="is-size-5">Số dư khách hàng trong 1 năm qua</strong> 
                    </div>
                    
                    <div class="field has-addons">
                      <div class="control ">
                        <a class="button is-static">
                          <i class="fa-solid fa-reply-all is-clickable" aria-hidden="true" @click="deFilterSearchTransaction"></i>
                        </a>
                      </div> 
                      <div class="control">
                        <input class="input" type="text" placeholder="Search transaction" v-model="searchTransactions">
                      </div>
                      <div class="control">
                        <a class="button is-static">
                          <i class="fa fa-search" aria-hidden="true"></i>
                        </a>
                      </div>
                      
                    </div>
                  </div>
                  <div class="is-flex is-flex-direction-row is-flex-grow-1 min-h-0 pr-2">
                    <v-card class="table-container is-flex-grow-1 table-transaction-height">
                      <v-data-table-virtual
                        id="table-transactions"
                        class="table-transaction-height"
                        :headers="headersTransactions"
                        :items="transactions"
                        :search="searchTransactions"
                        :custom-filter="customSearchTransaction"
                        fixed-header
                        density="compact"
                        sortable: false
                        items-per-page="1000"
                        width="100%"
                      >
                        <template   #item="{ item }" style="height: 40vh;">
                          <tr 
                          v-bind:class="[ (item.order_package_id === this.selectedPackId) ? 'is-active' : '', (item.order_package_id != 'na') ? 'is-clickable' : '']"
                          v-bind:id="[item.order_package_id+'-transaction-list']" class="row-transactions-list"
                          
                          @click="clickRowTransactionList" 
                          >
                            <td> {{ item.number }}</td>
                            <td> {{ item.transaction_date }}</td>
                            <td> {{ this.getWeekStr(item.week_id) }}</td>
                            <td class="has-text-right"> {{ this.formatPriceRound(item.amount_dr) }}</td>
                            <td class="has-text-right"> {{ this.formatPriceRound(item.amount_cr) }}</td>
                            <td  class="has-text-right"> {{ this.formatPriceRound(item.balance) }}</td>
                            <td> {{ item.description }}</td>
                          </tr>
                        </template >

                      </v-data-table-virtual>
                    </v-card>
                  </div>
                  
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="is-one-fifth is-flex-grow-1 has-background-light is-flex is-flex-direction-column note-holder side-panel" style="width: 20%; max-width: 20%;">
        <div class="is-flex is-flex-direction-column p-2">
          <div class="is-flex-grow-1 is-flex is-flex-direction-column">
            <div class="top-addon pl-2 pr-2 pb-1">
              <div class=" is-flex is-flex-direction-row pt-2 form-icon-line" >
                <div class="pl-2 pb-0" style="width: 17%;">
                  Week
                </div>
                <div class="pl-2 is-flex is-flex-direction-row is-size-5 form-input-type-holder is-align-items-center" style="width: 50%;">
                  
                  <i class="fa-solid fa-basket-shopping has-text-centered is-active form-input form-input-type is-clickable order" @click="formInputIcon" style="width: 31%;"></i>
                  <i class="fa-solid fa-credit-card  has-text-centered  form-input form-input-type is-clickable payment" @click="formInputIcon" style="width: 31%;"></i>
                  <i class=" has-text-centered " style="width: 31%;"></i>
                  
                </div>
                <div class="is-flex is-flex-direction-row pl-2 form-input-channel-holder is-size-5 is-align-items-center" style="width: 32%;">
                  <i class="fa-solid fa-square-phone-flip  has-text-centered form-input is-active form-input-channel is-clickable phone" @click="formInputIcon" style="width: 50%;"></i>
                </div>
              </div>
              <div class="is-flex is-flex-direction-row pb-0 form-icon-line" >
                <div class="pl-2 pt-0 pb-0" style="width: 17%;">
                  <strong class="week_id-note-week_str pb-0 pt-0"> </strong>
                </div>
                <div  class="is-flex is-flex-direction-row pl-2  is-size-5 form-input-type-holder is-align-items-center" style="width: 50%;">
                  <i class="fa-solid fa-motorcycle  has-text-centered  form-input form-input-type is-clickable ship" @click="formInputIcon" style="width: 31%;"></i>
                  <i class="fa-solid fa-ban  has-text-centered  form-input form-input-type is-clickable cancel" @click="formInputIcon" style="width: 31%;"></i>
                  <i class="fa-solid fa-circle-question  has-text-centered  form-input form-input-type is-clickable other" @click="formInputIcon" style="width: 31%;"></i>
                  
                </div>
                <div style="width: 32%;" class="is-flex is-flex-direction-row pl-2 form-input-channel-holder is-size-5 is-align-items-center">
                  <i class="fa-brands fa-square-facebook  has-text-centered form-input form-input-channel is-clickable facebook" @click="formInputIcon" style="width: 50%;"></i>
                  <i class="fa-solid  fa-square-minus  has-text-centered form-input form-input-channel is-clickable other" @click="formInputIcon" style="width: 50%;"></i>
                </div>
              </div>
            </div>
            <textarea class="textarea has-fixed-size textarea-note" placeholder="note description" @input="evaluateCreateNote"></textarea>
            <div class="bottom-addon is-flex is-flex-direction-row is-justify-content-center p-2 is-clickable disabled" id="button-create-note" @click="submitCreateNote" >
              CREATE <i class="week-chonsen-check-create-note pl-2"> </i>
            </div>
          </div>
        </div>
        <div class="pl-2 is-flex is-flex-direction-row pb-1">
          <div>
            <input type="checkbox" v-model="autoInsertWeek" class="ml-1 mr-1" @click="setAutoInsertWeek">
          </div>
          
          <div class="field has-addons is-justify-content-end pr-0" style="width:90%">
            <div class="control ">
              <a class="button is-static">
                <i class="fa-solid fa-reply-all is-clickable" aria-hidden="true" @click="deFilterNotes"></i>
              </a>
            </div> 
            <div class="control">
              <input class="input" type="text" id="note-search-input" placeholder="Search Note" v-model="searchNote">
            </div>
            <div class="control">
              <a class="button is-static">
                <i class="fa fa-search" aria-hidden="true"></i>
              </a>
            </div> 
          
          </div>  
        </div>
        
        <div class="is-flex-grow-1 min-h-0 p-2 pb-3">
          <v-card class="table-container note-holder-scroll table-note-height" >
            <v-data-table-virtual
              id="table-main-note"
              class="table-note-height"
              :headers="headersNote"
              :items="notes"
              :search="searchNote"
              :custom-filter="customSearchNote"
              fixed-header
              sortable: false
              width="100%"
              items-per-page="1000"
              
            >
            <template  #item="{ item }">
              <tr >
                
                <td v-bind:class="[(item.is_completed==1) ? 'completed-note' : 'pending-note',
                  item.week_id+'-note-week_id',
                  (this.weeks[4]['id'] === item.week_id) ? 'current-week-notes' : ''
                  
                ]">  
                  <strong>{{ item.weekStr +' '}} </strong>
                  {{ item.description }}
                  <i> ({{ item.created_by_id +' | '  }} {{ item.created.slice(5,10).replace('-','') }}:{{ item.created.slice(11,16).replace(':','') }})</i>
                  <strong> ({{  item.is_completed_string}})</strong>
                </td>
              </tr>
            </template >

            </v-data-table-virtual>

          </v-card>
        </div>
      </div>
    </div>

  </div>

  <div v-show="showCreateAddress"
      class="is-overlay  has-text-centered is-justify-content-center is-justify-items-center pt-15"
      style="background-color: rgba(0, 0, 0, 0.5); width: 100%; height: 100%; z-index: 2980; " >
    <div style="width:100%" class="is-flex is-justify-content-center is-justify-items-center" >
      <div class="column cust_create_wrapper p-0 p-3" style="max-width: 50%; background-color: rgba(255, 255, 255, 1);">
        <div class="column is-flex pl-0 pr-0 pt-1 pb-1 cust_focus_info_title is-flex-grow-0 has-background-warning" >
          <div class="column has-text-center pt-0 pb-0">
            <strong>CREATE ADDRESS</strong>
          </div>
        </div>
        <form @submit.prevent="submitForm" class="mt-2">
          <div class="field">
            <label class="label has-text-left">Address</label>
            <div class="control">
              <textarea class="input" style="height: 4rem;" type="text" id='createadd_cust_address' placeholder="customer_address" 
              @change="formAddChangeCreateAddForm"
              > </textarea>
            </div>
          </div>
          <div class="field">
            <label class="label has-text-left">District</label>
            <div class="control">

              <select name="district" id="createadd_cust_address_district" class="input"  v-model="selectedDistrict" disabled>
                <option value="na">na</option>
                <option v-for="( key) in districts" :key="key" v-bind:value="key">
                  {{ key }}
                </option>
              </select>
            </div>
          </div>
          <div class="field">
            <label class="label has-text-left">Ward</label>
            <div class="control">

              <select name="district" id="createadd_cust_address_ward" class="input" v-model="selectedWard" disabled>
                <option value="na">na</option>
                <option v-for="( key) in wards_selected_district" :key="key" v-bind:value="key">
                  {{ key }}
                </option>
              </select>
            </div>
          </div>
          <!-- Ship Loc is hidden: it is no longer picked or displayed here. On submit
               ship_dis is derived from the selected New Ward (see shipDisFromNewWard). -->
          <div class="field" v-if="false">
            <label class="label has-text-left">Ship Loc</label>
            <div class="control">
              <div class="select is-fullwidth">
                <select id="createadd_cust_ship_dis" style=" overflow-y: auto;" v-model="selectedShipDis" disabled>
                  <option value="na">na</option>
                  <option v-for="(item, key) in ship_dis" :key="key" v-bind:value="item.shipDis">
                    {{ item.shipDis }} - {{ Math.floor(item.price / 5).toLocaleString() + ' đ/ngày' }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="field">
            <label class="label has-text-left">New Ward</label>
            <div class="control">
              <v-autocomplete
                ref="newWardAuto"
                v-model="selectedNewWard"
                :items="newWardOptions"
                item-title="title"
                item-value="value"
                :custom-filter="newWardFilter"
                :menu-props="{ zIndex: 3000 }"
                density="compact"
                variant="outlined"
                hide-details
                auto-select-first
                placeholder="Type to search new ward…"
                @update:model-value="onNewWardChange"
              ></v-autocomplete>
            </div>
          </div>
          <div class="field">
            <div class="control">
              <div class="column" v-if="createAddFormErrors.length">
                <div class="notification is-danger p-1"  >
                  <p v-for="error in createAddFormErrors" v-bind:key="createAddFormErrors"> {{ error }}</p>
                </div>
              </div>
              <!-- <button class="button is-primary" @click="submitFormLogin">Login</button> -->
              <div class="is-flex is-justify-content-end">
                <button class="button is-warning" @click="submitFormCreateAddress"> <strong>CREATE ADDRESS</strong> </button>
                <button class="button  ml-2 has-background-danger" @click="this.showCreateAddress = false"> <strong>CANCEL</strong> </button>
              </div>

            </div>
          </div>
        </form>
      </div>
    </div>
  </div>


</template>


<script>
import axios from 'axios'
// import Multiselect from 'vue-multiselect'
import { findBestMatch } from '@/helpers/js_helpers.js';
import { VDataTable,VCard,VTextField,VDataTableVirtual,VFooter,VAutocomplete,VCheckbox} from 'vuetify/components'
import { parse } from '@vue/compiler-sfc';
import { nextTick } from 'vue';
export default {
  name: 'OrderHistView',
  components: {
    VDataTable,
    VCard,
    VTextField,
    VDataTableVirtual,
    VFooter,
    VAutocomplete,
    VCheckbox,
    
  },

  data() {
    return {
      // lock_create_order_totally: "1330-1329",
      // max_week_with_order: 0,
      // historyHolder: [],
      // custHAsOrderBefore: true,
      // lock_planning_allow: 2,
      // hasPendingNewOrder: false,
      showExpandCust: true,
      // listenDrop: false,
      // dragged_elem: null,
      // holidays: [],
      // max_allow_number: 50,
      // showHistory: true,
      // editCreateFormSelectFocusValueSave: '',
      // editCreateFormSelectFocusValueSaveTimeSlot: '',
      new_wards: {},
      districts: [],
      old_wards: {},
      ward_to_new_ward: {},
      selectedDistrict: 'na',
      selectedDistrict_create_cust: 'na',
      selectedWard: 'na',
      selectedWard_create_cust: 'na',
      selectedNewWard: 'na',
      selectedNewWard_create_cust: 'na',
      selectedShipDis: 'na',
      selectedShipDis_create_cust: 'na',
      ship_dis: {},
      showCreateAddress: false,
      selectedforInBill: [],
      urlPassedWeek: 0,
      custName: '',
      custMainAddress: '',
      custMainPhone: '',
      traits: '',
      diets: '',
      custId : null,
      weeks : [],
      orders : [],
      notes : [],
      load3month: true,

      group_address : [],
      selectedWeek_id : 0,
      currentUser : 'UNS',
      selectedPackId : '',
      selectedPackIdLocal : '',
      createCustFormErrors: [],
      createAddFormErrors: [],
      showCreateCust : false,
      transactions : [],
      addressShowAll : false,
      mapDay: {
        2: 'mon',
        3: 'tue',
        4: 'wed',
        5: 'thu',
        6: 'fri',
      },
      search : '',
      searchNote : '',
      autoInsertWeek : true,
      searchTransactions : '',
      autocompleteSuggestions : [],
      autocompleteSuggestionsShow : [],
      autocompleteValue : '',
      arrowCounter: -1,
      threeMonthsAgoWeekId : 0,
      isOpenAutocomplete : false,
      headersNote : [
        {
          align: 'start',
          key: 'description',
          title: 'description',
          sortable: false,
        },
      ],

      headers : [
            {
            align: 'start',
            key: 'id',
            title: '',
            sortable: false,
          },
          {
            align: 'start',
            key: 'week_str',
            title: 'weekStr',
            sortable: false,
          },
          {
            align: 'start',
            key: 'packageLocalId',
            title: 'id(Week)',
            sortable: false,
          },
          {
            align: 'start',
            key: 'packAlias',
            title: 'pack',
            sortable: false,
          },
          {
            align: 'start',
            key: 'shipLoc',
            title: 'shipLoc',
            sortable: false,
          },
          {
            align: 'start',
            key: 'finalAmt',
            title: 'Total',
            sortable: false,
          },
          {
            align: 'start',
            key: 'customerNote',
            title: 'Ghi Chú Phần Ăn',
            sortable: false,
          },
          
        ],

      headersTransactions : [
        {
          align: 'start',
          key: 'number',
          title: 'STT',
          sortable: true,
        },
        {
          align: 'start',
          key: 'transaction_date',
          title: 'date',
          sortable: false,
        },
        {
          align: 'start',
          key: 'week_id',
          title: 'week',
          sortable: false,
        },
        {
          align: 'start',
          key: 'amount_dr',
          title: 'Tiền_ăn',
          sortable: false,
        },
        {
          align: 'start',
          key: 'amount_cr',
          title: 'Tiền_trả',
          sortable: false,
        },
        {
          align: 'start',
          key: 'balance',
          title: 'Thiếu_(dư)',
          sortable: false,
        },
        {
          align: 'start',
          key: 'description',
          title: 'Description',
          sortable: false,
        },
        
      ],

      headersAddress : [
          {
            align: 'start',
            key: 'address_detail',
            title: '',
            sortable: false,
          },
      ]
    }
  },

  methods: {
    sendInBill () {
      const routeData = this.$router.resolve( {name: 'InBill', query: {
                                                                              customer_id: this.custId ,
                                                                              packs: this.selectedforInBill.join(';')
                                                                              }}
                                                        );
      window.open(routeData.href, '_blank');

      this.clearSelectedInBill()

    },

    clearSelectedInBill () {
      this.selectedforInBill = []
    },
    
    removeCurrentCustInfoValue (event) {
      this.autocompleteValue = ''
      this.filterAutocompleteResults();
      this.isOpenAutocomplete = true;

      document.getElementById('custinfo_cust_phone').focus()
      this.resetCustInfo()

    },

    clickAutocomplete (event) {
      this.formPhoneChange( {srcElement: {value: event.target.innerText}} , true)
    },

    handleClick (event) {

      try {
        if (!(event.target.classList.contains('autocomplete'))) {
          
          if (event.target.id === 'custinfo_cust_phone') {
            1==1
          } else {
            this.arrowCounter = -1
            document.getElementsByClassName('0-autocomplete-stt')[0].scrollIntoView({block: "nearest"});
            this.isOpenAutocomplete = false
          }
        }       
      } catch (error) {  1==1 }
      
    },
    
    custInfoKeyDown (event) {
      if ((event.key === 'Tab') && (this.isOpenAutocomplete)) {
        this.isOpenAutocomplete = false
        this.arrowCounter = -1;
      }

      if ((event.key === 'Tab')) {
        document.getElementsByClassName('de-filter-order-list')[0].focus()
      }


      if (event.key === 'ArrowDown') {
        this.isOpenAutocomplete = true;
        this.filterAutocompleteResults();
        this.arrowCounter = this.arrowCounter + 1
        
        if (this.arrowCounter >= this.autocompleteSuggestionsShow.length) {
          this.arrowCounter = 0
          
        }
        document.getElementsByClassName(this.arrowCounter+'-autocomplete-stt')[0].scrollIntoView({behavior: "smooth", block: "nearest", inline: "nearest"});
      }

      if (event.key === 'ArrowUp') {
        this.arrowCounter = this.arrowCounter - 1
        if (this.arrowCounter < 0) {
          this.arrowCounter = this.autocompleteSuggestionsShow.length - 1
        }
        document.getElementsByClassName(this.arrowCounter+'-autocomplete-stt')[0].scrollIntoView({behavior: "smooth", block: "nearest", inline: "nearest"});
      }

      if (event.key === 'Enter') {
        if (this.arrowCounter > -1) {
          this.autocompleteValue = this.autocompleteSuggestionsShow[this.arrowCounter]
          this.formPhoneChange( {srcElement: {value: this.autocompleteValue}}, true)
        }
      }
      
      
    },

    custInfoInput (event) {
      this.filterAutocompleteResults();
      this.isOpenAutocomplete = true;
      this.arrowCounter = -1;
    },

    filterAutocompleteResults() {
      this.autocompleteSuggestionsShow = this.autocompleteSuggestions.filter(item => 
        item.replaceAll('-','').toLowerCase().indexOf(this.autocompleteValue.replaceAll('-','').toLowerCase()) > -1
        );
    },
    
    setAutoComplete (stringPassed) {
      
      if (stringPassed === 'init') {
        try {
          this.autocompleteSuggestions = localStorage.getItem('searchHist').split('|||').concat(this.autocompleteSuggestions)
          this.autocompleteSuggestions = this.autocompleteSuggestions.filter((v, i, a) => a.indexOf(v) === i)
        } catch (error) {
          1==1
        }
        return
      }
      let localSearchHist = ''
      try { localSearchHist = localStorage.getItem('searchHist')
      } catch (error) {
        localSearchHist = ''
      }
      
      // first time set
      if ((localSearchHist === '') || (localSearchHist === null)){

        localStorage.setItem('searchHist', stringPassed)
        
        this.autocompleteSuggestions = [stringPassed].concat(this.autocompleteSuggestions)

        this.autocompleteSuggestions = this.autocompleteSuggestions.filter((v, i, a) => a.indexOf(v) === i)
        return
      } 


      let curResult = stringPassed.split(':')
      if (localSearchHist.indexOf(stringPassed)>-1) {
        localSearchHist = localSearchHist.replaceAll(stringPassed+'|||', '')
        let newSearchHist = stringPassed + '|||' + localSearchHist 
        localStorage.setItem('searchHist', newSearchHist)
        this.autocompleteSuggestions = localStorage.getItem('searchHist').split('|||').concat(this.autocompleteSuggestions)
        this.autocompleteSuggestions = this.autocompleteSuggestions.filter((v, i, a) => a.indexOf(v) === i)
        return
      } 

      let newSearchHist = stringPassed + '|||' + localSearchHist 
      localStorage.setItem('searchHist', newSearchHist)
      let arraySuggest = newSearchHist.split('|||')

      

      if (arraySuggest.length > 100) {
        arraySuggest = arraySuggest.slice(0,99)
      }
      localStorage.setItem('searchHist', arraySuggest.join('|||'))

      this.autocompleteSuggestions = newSearchHist.split('|||').concat(this.autocompleteSuggestions)
      this.autocompleteSuggestions = this.autocompleteSuggestions.filter((v, i, a) => a.indexOf(v) === i)

      if (arraySuggest.join('|||').replaceAll('|||', '').indexOf('|')>-1) {

        localStorage.removeItem('searchHist')
        // this.autocompleteSuggestions = []

      }
    },

    formPhoneChangeCreateForm (event) {
      
      let myString = event.srcElement.value
      myString = myString.replace(/[^\d]/g, "")
      myString = myString.substring(0, 10)
      document.getElementById('createCust_cust_phone').value = myString
    },

    async formAddChangeCreateAddForm (event) {
      
      let myString = event.target.value
      // remove newline
      myString = myString.replace(/(\r\n|\n|\r)/gm, "")

      event.target.value = myString.trimStart().trimEnd()
      const encoded = encodeURIComponent(myString)
      this.$store.commit('setIsLoading', true)

      await axios
          .get('/api/v1/clean_address/?address='  + encoded)
          .then(response => {
            // Auto-clean gives us the old ward + new ward. New ward then drives
            // district + shipLoc, and the old ward is blanked if it conflicts.
            if (response.data['status']) {
              this.selectedWard = response.data['phuong_string'] || 'na'
              this.selectedNewWard = response.data['new_ward_string'] || 'na'
            } else {
              this.selectedWard = 'na'
              this.selectedNewWard = 'na'
            }
            this.onNewWardChange()
            this.syncNewWardSearch('newWardAuto', this.selectedNewWard)
            this.$store.commit('setIsLoading', false)
          })
          .catch(error => {
            this.selectedWard = 'na'
            this.selectedNewWard = 'na'
            this.onNewWardChange()
            this.syncNewWardSearch('newWardAuto', this.selectedNewWard)
            this.$store.commit('setIsLoading', false)
          })

    },

    async formAddChangeCreateForm (event) {
      
      let myString = event.target.value
      
      // remove newline
      myString = myString.replace(/(\r\n|\n|\r)/gm, "")
      event.target.value = myString.trimStart().trimEnd()
      const encoded = encodeURIComponent(myString)
      
      this.$store.commit('setIsLoading', true)
      await axios
          .get('/api/v1/clean_address/?address='  + encoded)
          .then(response => {
            // Auto-clean gives us the old ward + new ward. New ward then drives
            // district + shipLoc, and the old ward is blanked if it conflicts.
            if (response.data['status']) {
              this.selectedWard_create_cust = response.data['phuong_string'] || 'na'
              this.selectedNewWard_create_cust = response.data['new_ward_string'] || 'na'
            } else {
              this.selectedWard_create_cust = 'na'
              this.selectedNewWard_create_cust = 'na'
            }
            this.onNewWardChange_create_cust()
            this.syncNewWardSearch('newWardAutoCreateCust', this.selectedNewWard_create_cust)
            this.$store.commit('setIsLoading', false)
          })
          .catch(error => {
            this.selectedWard_create_cust = 'na'
            this.selectedNewWard_create_cust = 'na'
            this.onNewWardChange_create_cust()
            this.syncNewWardSearch('newWardAutoCreateCust', this.selectedNewWard_create_cust)
            this.$store.commit('setIsLoading', false)
          })

    },

    validateEmail(email) {
      var re = /\S+@\S+\.\S+/;
      return re.test(email);
    },

    custInfoControl (event) {

      if (event.srcElement.id === 'custinfo') {
        this.showCreateCust = false
      } else {
        this.showCreateCust = true
      }
      
    },
    
    resetCustCreateForm () {
      document.getElementById('createCust_cust_name').value = ''
      document.getElementById('createCust_cust_phone').value = ''
      document.getElementById('createCust_cust_address').value = ''
      document.getElementById('createCust_cust_email').value = 'na@na.com'
      this.selectedDistrict_create_cust = 'na'
      this.selectedWard_create_cust = 'na'
      this.selectedShipDis_create_cust = 'na'
      this.selectedNewWard_create_cust = 'na'

      this.createCustFormErrors = []
      this.showCreateCust = false
    },

    async submitFormCreateAddress () {
      this.$store.commit('setIsLoading', true)
      this.createAddFormErrors = []
      
      if (document.getElementById('createadd_cust_address').value.length <= 10) {
                this.createAddFormErrors.push('The customer Address must have at least 10 characters')
            }
      // console.log(this.group_address)
      let exclude_fake_address = this.group_address.filter(item => item.id > 0 && typeof item.ship_dis === "string" && item.ship_dis.length > 0)
      let filtered_address = exclude_fake_address.filter(item => item.address_detail === document.getElementById('createadd_cust_address').value)
      if (filtered_address.length > 0) {
        this.createAddFormErrors.push('This address already exists for this customer')
      }

      let include_address = exclude_fake_address.filter(item => item.address_detail.includes(document.getElementById('createadd_cust_address').value))
      if ((include_address.length > 0) && (document.getElementById('createadd_cust_address').value.length >= 10)&&(filtered_address.length === 0)) {
        this.createAddFormErrors.push('This address already exists for this customer')
      }

      if (this.custId === null) {
        this.createAddFormErrors.push('Please select a customer first')
      }

      // District + New Ward are required; old ward may be blank (auto-filled from new ward).
      if (this.selectedNewWard === 'na' || !this.selectedNewWard) {
        this.createAddFormErrors.push('Please select a New Ward')
      }

      if (this.selectedDistrict === 'na' || !this.selectedDistrict) {
        this.createAddFormErrors.push('Please select a District')
      }

      // No Ship Loc check: ship_dis is derived from New Ward, which is already
      // required above, so it can no longer fail independently.



      
      if (this.createAddFormErrors.length) {
        this.$store.commit('setIsLoading', false)
        return
      } else {
        const formData = {
                customer_id: this.custId,
                name: this.custName,
                phone_number: this.custMainPhone.replaceAll('-',''),
                phone_number_readable: this.custMainPhone,
                address_detail: document.getElementById('createadd_cust_address').value,
                created_by_id: this.currentUser,
                last_edited_by_id: this.currentUser,
                ward_str : (this.selectedWard === 'na' ? '' : this.selectedWard),
                district_str : document.getElementById('createadd_cust_address_district').value,
                ship_dis: this.shipDisFromNewWard(this.selectedNewWard),
                new_ward_str: ((this.selectedNewWard === 'na' || !this.selectedNewWard) ? '' : this.selectedNewWard),
                }

        await axios
          .post('/api/v1/customer-address-create/', formData)
          .then(response => {
            this.createAddFormErrors = []
            this.group_address = response.data
            this.$store.commit('setIsLoading', false)
            this.showCreateAddress = false
          })
          .catch(error => {
            this.createAddFormErrors.push(error.response.data)
            this.$store.commit('setIsLoading', false)
          })
      }
    },

    async submitFormCreateCust (event) {
      event.target.disabled = true
      this.$store.commit('setIsLoading', true)
      this.createCustFormErrors = []

      if (document.getElementById('createCust_cust_name').value === '') {
                this.createCustFormErrors.push('The customer Name is missing')
            }
      if (document.getElementById('createCust_cust_phone').value === '') {
                this.createCustFormErrors.push('The customer Phone is missing')
            }
      if (document.getElementById('createCust_cust_address').value === '') {
                this.createCustFormErrors.push('The customer Address is missing')
            }
      if (document.getElementById('createCust_cust_email').value === '') {
                this.createCustFormErrors.push('The customer Email is missing')
            }
      if (document.getElementById('createCust_cust_phone').value.length != 10) {
                this.createCustFormErrors.push('The customer Phone must have 10 digits')
            }
      // District + New Ward are required; old ward may be blank (auto-filled from new ward).
      if (this.selectedNewWard_create_cust === 'na' || !this.selectedNewWard_create_cust) {
        this.createCustFormErrors.push('Please select a New Ward')
      }

      if (this.selectedDistrict_create_cust === 'na' || !this.selectedDistrict_create_cust) {
        this.createCustFormErrors.push('Please select a District')
      }

      // No Ship Loc check: ship_dis_str is derived from New Ward, which is already
      // required above, so it can no longer fail independently.

      if (!this.validateEmail(document.getElementById('createCust_cust_email').value)) {
                this.createCustFormErrors.push('The customer Email is not valid')
            }

      
      if (this.createCustFormErrors.length) {
        this.$store.commit('setIsLoading', false)
        event.target.disabled = false
        return
      } else {
        const formData = {
                name: document.getElementById('createCust_cust_name').value,
                main_address: document.getElementById('createCust_cust_address').value,
                main_phone: document.getElementById('createCust_cust_phone').value,
                email:document.getElementById('createCust_cust_email').value,
                last_edited_by_id: this.currentUser,
                ward_str : (this.selectedWard_create_cust === 'na' ? '' : this.selectedWard_create_cust),
                district_str : document.getElementById('createCust_cust_address_district').value,
                ship_dis_str: this.shipDisFromNewWard(this.selectedNewWard_create_cust),
                new_ward_str: ((this.selectedNewWard_create_cust === 'na' || !this.selectedNewWard_create_cust) ? '' : this.selectedNewWard_create_cust)
                }
        // axios.defaults.baseURL = 'https://api.fitfood.io.vn'
        await axios
          .post('/api/v1/customer/', formData)
          .then(response => {
            
            this.createCustFormErrors = []
            this.resetCustCreateForm()
            this.autocompleteValue = response.data['main_phone']
            document.getElementById('custinfo_cust_phone').value = response.data['main_phone']
            this.phoneChanged({srcElement: {value: response.data['main_phone']}})
            this.$store.commit('setIsLoading', false)
            event.target.disabled = false

          })
          .catch(error => {
            this.createCustFormErrors.push(error.response.data)
            this.$store.commit('setIsLoading', false)
            event.target.disabled = false
          })
      }
    },

    deFilterOrderList (event) {
      
      this.search = ''
    },

    deFilterSearchTransaction (event) {
      
      this.searchTransactions = ''
    },

    deFilterNotes (event) {
      document.getElementById('note-search-input').value = ''
      this.searchNote = ''
    },

    evaluateCreateNote (event) {
      let noteButton = document.getElementById('button-create-note')
      let weekStr = document.getElementsByClassName('week_id-note-week_str')[0].innerText
      let filledWeekStr = !(weekStr==='')
      let filledNote = !(document.getElementsByClassName('textarea-note')[0].value==='')
      let selectedWeek_id = this.selectedWeek_id === 0 ? false : true
      let custId = this.custId === null ? false : true
      let name = this.custName === '' ? false : true
      let main_phone = this.custMainPhone === '' ? false : true

      let week5limit = this.selectedWeek_id > this.weeks[5].id

      if (week5limit) {
        document.getElementsByClassName('week-chonsen-check-create-note')[0].innerText = ''
      } else {
        document.getElementsByClassName('week-chonsen-check-create-note')[0].innerText = '(Note within 5 weeks)'
      }

      if (filledWeekStr && filledNote && selectedWeek_id && custId && name && main_phone && week5limit) {
        noteButton.classList.remove('disabled')
      } else {
        noteButton.classList.add('disabled')
      }
    },

    formInputIcon (event) {
      if (event.srcElement.classList.contains('form-input-type')) {
        let allActive = document.getElementsByClassName('form-input-type')
        Array.from(allActive).forEach(element => {
          element.classList.remove('is-active')
        });
        event.srcElement.classList.add('is-active')
      } else if (event.srcElement.classList.contains('form-input-channel')) {
        let allActive = document.getElementsByClassName('form-input-channel')
        Array.from(allActive).forEach(element => {
          element.classList.remove('is-active')
        });
        event.srcElement.classList.add('is-active')
      }
    },

    getWeekStr (week_id) {

      let start_date_id = this.weeks.find(week => week.id === week_id)

      if (typeof start_date_id?.start_date_id === 'undefined') {
        return ''
      }

      if (start_date_id === undefined) {
        return week_id.toString()
      } else  {

        start_date_id = start_date_id.start_date_id.toString()
        return  start_date_id.slice(6,8) + '.' + start_date_id.slice(4,6)
      }
   
    },
    
    async clickRowOrderList (event) {

      let parent = event.srcElement
        while (!parent.classList.contains('row-order-list')) {
          if (parent.parentElement === null) {
            break
          }
          parent = parent.parentElement
        }
      // handle by v-table bind
      // parent.classList.add('is-active')

      // orderpacks-holder
      let breakPoint = parent.id.indexOf('-order-list')
      let id = parent.id.slice(0,breakPoint)
      // console.log('id',id)
      // console.log('document.getElementById(id)',document.getElementById(id).querySelector('.orderpack-detail-title'))

      await document.getElementById(id).click(true)
      try { document.getElementById(id).scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' }) } catch (error) {1==1}     
      document.querySelector('div.week-holder.selected').scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' }) 
      
    },

    async clickRowTransactionList (event) {

      let parent = event.srcElement
        while (!parent.classList.contains('row-transactions-list')) {
          if (parent.parentElement === null) {
            break
          }
          parent = parent.parentElement
        }
      // handle by v-table bind
      // parent.classList.add('is-active')

      // orderpacks-holder
      if (parent.id === 'na-transaction-list') {
            return
      }
      let breakPoint = parent.id.indexOf('-transaction-list')
      let id = parent.id.slice(0,breakPoint)
      await document.getElementById(id).click(true)
      
      // scroll to order for history
      try { document.getElementById(id).scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' }) } catch (error) {1==1}     
      document.querySelector('div.week-holder.selected').scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' }) 
      
    },

    customSearch (value, search, item) {
      search = search.toString()
      for (let [key, value] of Object.entries(item['raw'])) {
        try { if (value.toString().toLowerCase().includes(search.toString().toLowerCase())) { return true} } catch (error) {1==1}
      }
      return false
    },

    customSearchTransaction (value, search, item) {
      for (const [key, value] of Object.entries(item['raw'])) {
        try { if (value.toString().toLowerCase().includes(search.toString().toLowerCase())) { return true} } catch (error) {1==1}
      }
      return false
    },

    customSearchNote (value, search, item) {
      for (const [key, value] of Object.entries(item['raw'])) {
        try { if (value.toString().toLowerCase().includes(search.toString().toLowerCase())) { return true} } catch (error) {1==1}
      }
      return false
    },

    showControl (event) {

      ['orderList','customerBalance','info','details'].forEach(target => {
        if (event.srcElement.id === target) {
          event.srcElement.classList.add('is-active')
          document.getElementsByClassName(target+'-control-class')[0].classList.add('is-active')
          
          // try { document.querySelector('.pack-table-tbody.is-active').scrollIntoView() } catch (error) {1==1}     
          if (target === 'details') {
            try { document.querySelector('div.pack-table-tbody.is-active').scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' }) } 
            catch (error) {}     
          }

          if (target === 'customerBalance') {
            try { document.querySelector('.row-transactions-list.is-active').scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' }) } 
            catch (error) {            }     
          }

          if (target === 'orderList') {
            try { document.querySelector('.row-order-list.is-active').scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' }) } 
            catch (error) {}     
          }


        } else {
          
          document.getElementById(target).classList.remove('is-active')

          document.getElementsByClassName(target+'-control-class')[0].classList.remove('is-active')
        }
      });

    },

    formatPriceRound (price) {
      return Math.round(price).toLocaleString('en-US')
    },

    resetPackInfo () {
      let priceHolder = document.getElementsByClassName('price-holder')[0]
      if (priceHolder) {
        let toBeDestroyed = priceHolder.getElementsByClassName('to-destroy-price')
        Array.from(toBeDestroyed).forEach(element => {
          element.remove()
        });
      }

      let toBeDestroyedPackTable = document.getElementsByClassName('to-destroy-pack-table')
      Array.from(toBeDestroyedPackTable).forEach(element => {
        element.remove()
      });

      let detailHolder = document.getElementsByClassName('detail-holder-info-order-info')[0]
      if (detailHolder) {
        let toReset = detailHolder.getElementsByClassName('to-reset-inner-html')
        Array.from(toReset).forEach(element => {
          element.innerHTML = ''
        });
      }

      let toWrapToogle = document.getElementsByClassName('nowrap-toogle')
      Array.from(toWrapToogle).forEach(element => {
        element.classList.add('nowrap')
      });


      let rowOrderList = document.getElementsByClassName('row-order-list')
      Array.from(rowOrderList).forEach(element => {
        element.classList.remove('is-active')
      });

      let noteSearchInput = document.getElementById('note-search-input')
      if (noteSearchInput) noteSearchInput.value = ''

    },

    async selectPack (event, scrollToPackTable = true) {
      // remove old selected
      let allSelected = document.getElementsByClassName('selected')
      await Array.from(allSelected).forEach(element => {
        element.classList.remove('selected')
        this.selectedPackId = ''
        this.selectedPackIdLocal = ''
        this.selectedWeek_id = 0
      });

      // for orderpacks-holder
      // look for the selected orderpacks-holder
      let currElement = event.srcElement

      if (currElement.classList.contains('orderpacks-holder')) {
        currElement.classList.add('selected')
      } else {
        let parent = currElement
        while (!parent.classList.contains('orderpacks-holder')) {
          if (parent.parentElement === null) {
            break
          }
          parent = parent.parentElement
        }
        parent.classList.add('selected')
      }

      // test if a pack-holder is selected
      // even if no pack is selected, the week-holder will be selected
      try {
        this.selectedPackId = document.querySelector('.orderpacks-holder.selected').id
        this.selectedPackIdLocal = document.querySelector('.orderpacks-holder.selected').getElementsByClassName('pack-id')[0].innerText
      } catch (error) {1==1}
      
      // for week-holder
      // test if a pack-holder is selected
      if (currElement.classList.contains('week-holder')) {
        currElement.classList.add('selected')
      } else {
        let parent = currElement
        while (!parent.classList.contains('week-holder')) {
          if (parent.parentElement === null) {
            break
          }
          parent = parent.parentElement
        }
        await parent.classList.add('selected')
        
      }

      //  set selected week id variable
      this.selectedWeek_id = parseInt(document.querySelector('.week-holder.selected').id)
      // destroy price append elements
      await this.resetPackInfo()

      // let toResetInfo = document.getElementsByClassName('order-info-part-1')[0].getElementsByClassName('to-reset-inner-html')

      
      // for week-selected
      let selectedWeekElement = document.querySelector('.week-holder.selected')
      // console.log(selectedWeekElement)
      let allSlectedPack = this.orders.filter(order => order.week_id === parseInt(selectedWeekElement.id))
      let packTableHolder = document.getElementsByClassName('pack-table-holder')[0]
      allSlectedPack.forEach(pack1 => {
        // template-package-table
        // console.log(pack1)
        let packTable = document.querySelector('.template-package-table').cloneNode(true)
        packTable.id = pack1['id'] + '-pack-table'
        let packAlias = pack1['packAlias']
        if (pack1['ycdb2'] === 'Thêm phần ăn sáng dành cho gói MEAT LOVER') {
          packAlias = packAlias.replace('MEAT', 'MEAT-S')
        }
        
        packTable.getElementsByClassName('id-pack-table')[0].innerHTML = packAlias
        
        packTable.getElementsByClassName('packageLocalId-pack-table')[0].innerHTML = '(id:' + pack1['packageLocalId'] + ')'
        packTable.classList.remove('template-package-table')
        packTable.classList.remove('is-hidden')
        packTable.classList.add('to-destroy-pack-table')
        // console.log(packTable)
        // pack-table-tbody
        let fullStrDb = pack1['fullStrDB']
        if ((fullStrDb === null) || (fullStrDb === undefined) || (fullStrDb === '')) {
          fullStrDb = {}
        } else {
          fullStrDb = JSON.parse(fullStrDb)
          Object.keys(fullStrDb).forEach(day => {
            let buoiStr = fullStrDb[day]
            Object.keys(buoiStr).forEach(buoi => {
              // console.log('resetPackInfo')
              // console.log('pack-table-'+buoi)
              let buoiElement = packTable.getElementsByClassName('pack-table-'+buoi)[0].getElementsByClassName('day-'+day)[0]
              let valueinput = buoiStr[buoi]
              
              if (['SA','TR','TO'].includes(buoi)) {
                let start = valueinput.indexOf('(')
                let end = valueinput.lastIndexOf(')')
                let tLength = valueinput.length
                if (start != -1) {
                  let strDB = valueinput.slice(start+1,end)
                  let normalStr = valueinput.slice(0,start) + valueinput.slice(end+1,tLength)
                  valueinput = '<strong>' + normalStr + '</strong>' + '<br><i>' + strDB.toLowerCase() + '</i>'
                } else {
                  valueinput = '<strong>' + valueinput + '</strong>'
                }
                
                buoiElement.innerHTML = valueinput
              } else {
                buoiElement.innerHTML = '<strong>' + buoiStr[buoi] + '</strong>'
              }
              
            });
          });
        }
        
        

        let shipStr = pack1['shipStr']
        if ((shipStr === null) || (shipStr === undefined) || (shipStr === '')) {
          shipStr = {}
        } else {
          shipStr = JSON.parse(shipStr)
          Object.keys(shipStr).forEach(day => {
            let oneDayShip = shipStr[day]['details']
            Object.keys(oneDayShip).forEach(key => {
              try {
                let shipElement = packTable.getElementsByClassName('pack-table-'+key)[0].getElementsByClassName('day-'+day)[0]
                shipElement.innerHTML = oneDayShip[key]
              } catch (error) {
                // console.log(error)
                1==1
              }
              
            });
          });
        }

        
        //  only create if have products
        let fullStr = pack1['fullStr']
        if ((fullStr === null) || (fullStr === undefined) || (fullStr === '')) {
          1==1
        } else {
          packTableHolder.appendChild(packTable)
        }
        

      });
      // end of week-selected
      
      // for packTable selected
      try {
        await document.getElementsByClassName('pack-table-holder')[0].childNodes.forEach(element => {
          if (element.id == (document.querySelector('.orderpacks-holder.selected').id+'-pack-table')){
            element.classList.add('is-active')
          }
        });
      } catch (error) {
        1==1
        // console.log(error)
      }
      
      // end of packTable selected


      // for pack-selected sheet Info
      
      let selectedPack = document.querySelectorAll('.orderpacks-holder.selected')
      if (selectedPack.length > 0) {
        
        let selectedOrder = this.orders.find(order => order.id === selectedPack[0].id)
        let priceHolder = document.getElementsByClassName('price-holder')[0]
        let lineBreak = document.getElementsByClassName('line-break')[0]
        let infoArr = Object.keys(selectedOrder)
        infoArr.forEach(info => {
          try {
            if ((info === 'packAlias')&&(selectedOrder['ycdb2'] === 'Thêm phần ăn sáng dành cho gói MEAT LOVER')) {
              document.getElementsByClassName('packAlias-pack-info')[0].innerHTML = selectedOrder[info].replace('MEAT', 'MEAT-S')
            } else {
              let infoElement = document.getElementsByClassName(info+'-pack-info')[0]
              infoElement.innerHTML = selectedOrder[info]
            }
            
          } catch (error) {
            1==1
          }

          try {
            let infoElement = document.getElementsByClassName(info+'-pack-price')[0]
            if (info.includes('Amt')||info.includes('totalBeforeDis')) {
              infoElement.innerHTML = this.formatPriceRound(selectedOrder[info])
            } else if ((info === 'packAlias')&&(selectedOrder['ycdb2'] === 'Thêm phần ăn sáng dành cho gói MEAT LOVER'))  {
              infoElement.innerHTML = selectedOrder[info].replace('MEAT', 'MEAT-S')
            } else {
              infoElement.innerHTML = selectedOrder[info]
            }
            
          } catch (error) {
            1==1
          }
        });

        

        // ship 
        let shipStrPrice = selectedOrder['shipStrPrice']
        if ((shipStrPrice === undefined) || (shipStrPrice === null)) {
          1==1
        } else {
          
          shipStrPrice = JSON.parse(shipStrPrice)
          Object.keys(shipStrPrice).forEach(shipPackId => {
            let shipItem = shipStrPrice[shipPackId]
            Object.keys(shipItem).forEach(shipLoc => {
              let shipElement = document.getElementsByClassName('ship-details-this-order')[0].cloneNode(true)
              if (shipPackId != selectedOrder.id){
                shipElement = document.getElementsByClassName('ship-details-not-this-order')[0].cloneNode(true)
                shipElement.getElementsByClassName('packageLocalId-ship-item')[0].innerHTML = shipItem[shipLoc]['packageLocalId']
              }
              shipElement.classList.remove('is-hidden')
              shipElement.classList.add('to-destroy-price')
              shipElement.getElementsByClassName('shipLoc-ship-item')[0].innerHTML = shipLoc
              shipElement.getElementsByClassName('shipLoc-quant-ship-item')[0].innerHTML = shipItem[shipLoc]['count']
              shipElement.getElementsByClassName('ship-price-ship-item')[0].innerHTML = this.formatPriceRound(shipItem[shipLoc]['price'])
              
              priceHolder.insertBefore(shipElement,lineBreak)  

            });
          });

        }
        
        // điều chỉnh giá ship
        if (selectedOrder['shipPriceAdjAmt']!=0) {
            let sideOrderElement = document.getElementsByClassName('ship-price-details-adj')[0].cloneNode(true)
            sideOrderElement.classList.remove('is-hidden')
            sideOrderElement.classList.add('to-destroy-price')
            sideOrderElement.getElementsByClassName('ship-price-ship-item')[0].innerHTML = this.formatPriceRound(selectedOrder['shipPriceAdjAmt'])
            priceHolder.insertBefore(sideOrderElement,lineBreak)  

          }
        // end of ship

        // side order
        let sideStrFull = selectedOrder['sideStrFull']
        if ((sideStrFull === undefined)|| (sideStrFull === null)){
          1==1
        } else {
          sideStrFull = JSON.parse(sideStrFull)
          
          Object.keys(sideStrFull).forEach(sideProductName => {
            let sideOrder = sideStrFull[sideProductName]
            let attElement = document.getElementsByClassName('side-order-details')[0].cloneNode(true)
            attElement.classList.remove('is-hidden')
            attElement.classList.add('to-destroy-price')
            attElement.getElementsByClassName('side-order-name')[0].innerHTML = sideProductName 
            attElement.getElementsByClassName('side-order-quant')[0].innerHTML = sideOrder['quant']
            attElement.getElementsByClassName('side-order-price')[0].innerHTML = this.formatPriceRound(sideOrder['total'])

            priceHolder.insertBefore(attElement,lineBreak)
          });
        }
        // điều chỉnh giá side nếu có
        if (selectedOrder['sidePriceAdjAmt']!=0) {
            let attElement = document.getElementsByClassName('side-order-details-adj')[0].cloneNode(true)
            attElement.classList.remove('is-hidden')
            attElement.classList.add('to-destroy-price')
            attElement.getElementsByClassName('side-order-price')[0].innerHTML = this.formatPriceRound(selectedOrder['sidePriceAdjAmt'])
            priceHolder.insertBefore(attElement,lineBreak)
          }

        // end of side order

        // other Amt
        
        if (selectedOrder['specialAmt']!=0) {
            let attElement = document.getElementsByClassName('specialAmt-adj')[0].cloneNode(true)
            attElement.classList.remove('is-hidden')
            attElement.classList.add('to-destroy-price')
            // -pack-price already added innerHTML
            priceHolder.insertBefore(attElement,lineBreak)
          }

        // other End of other Amt


        // other Amt
        if (selectedOrder['otherAmt']!=0) {
            let attElement = document.getElementsByClassName('otherAmt-adj')[0].cloneNode(true)
            attElement.classList.remove('is-hidden')
            attElement.classList.add('to-destroy-price')
            // -pack-price already added innerHTML
            priceHolder.insertBefore(attElement,lineBreak)
          }

        // other End of other Amt


        // cancle nowrap 
        let toWrapToogle = document.getElementsByClassName('nowrap-toogle')
        Array.from(toWrapToogle).forEach(element => {
          let beforeH = element.offsetHeight
          element.classList.remove('nowrap')
          let afterH = element.offsetHeight
          if (beforeH < afterH) {
            element.classList.add('nowrap')
          }
        });
      };

      // end of pack-selected

      // change active order-list 
      try {
        
        let active_order_list = document.getElementsByClassName('row-order-list')
        Array.from(active_order_list).forEach(element => {
          if (element.id.slice(0,-('-order-list'.length)) === selectedPack[0].id.toString()) {
            element.classList.add('is-active')
          } else {
            element.classList.remove('is-active')
          }

        });
    
      } catch (error) {1==1}
        
      // end of change active order-list
      try { 
        1==1
        document.querySelector('div.week-holder.selected').scrollIntoView({ behavior: 'smooth', block: 'nearest'}) 
        document.querySelector('div.week-holder.selected .week-holder-inner .orderpacks-holder.selected').scrollIntoView({ behavior: 'smooth', block: 'nearest'}) 
      } catch (error) {1==1}     

      try { document.querySelector('.row-order-list.is-active').scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' }) } 
      catch (error) {1==1}     
      
      document.getElementById('note-search-input').value = document.querySelector('.week-holder.selected strong').innerHTML
      if (this.autoInsertWeek) {
        this.searchNote = document.querySelector('.week-holder.selected strong').innerHTML
      }
      
      document.getElementsByClassName('week_id-note-week_str')[0].innerHTML = document.querySelector('.week-holder.selected strong').innerHTML


      this.evaluateCreateNote(1000)

      // scroll to view 
      try { 
        let active_info_tab = document.querySelector('.control-item.is-active')
        
        if (active_info_tab.id==='details') {
          
            // 1 == 1
            document.querySelector('div.pack-table-tbody.is-active').scrollIntoView({ block: 'nearest' })     
          
          
        }

        if (active_info_tab.id==='orderList') {
          document.querySelector('.row-order-list.is-active').scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' })   
        }

        if (active_info_tab.id==='customerBalance') {
          document.querySelector('.row-transactions-list.is-active').scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' })   
        }

      } catch (error) {
        // console.log(error)
      }   

    },

    resetCustInfo() {
      this.custName = ''
      this.custMainAddress = ''
      this.custMainPhone = ''
      this.traits = ''
      this.diets = ''
      this.custId = null
      this.notes = []
      this.orders = []
      this.transactions = []
      this.selectedforInBill = []
      this.group_address = []

    },

    async formPhoneChange (event,byPass=false) {
      if (event.srcElement.value === null) {
        await this.makeHist([])
        try {this.scrollEnd()} catch (error) {1==1}
        return
      }
      if (!byPass) {
        if (this.autocompleteValue === '')  {
          await this.makeHist([])
          try {this.scrollEnd()} catch (error) {1==1}
          return
        }
      }
      

      let myString = event.srcElement.value
      myString = myString.replace(/[^\d]/g, "")
      myString = myString.substring(0, 10)
      this.autocompleteValue = myString
      document.getElementById('custinfo_cust_phone').value = myString

      if (myString.length < 10) {
        this.resetCustInfo()
        this.resetPackInfo()
        await this.makeHist([])
        try {this.scrollEnd()} catch (error) {1==1}
        return
      }
      
      this.phoneChanged(event)
    },

    async phoneChanged (event) {
      this.$store.commit('setIsLoading', true)
      let myString = event.srcElement.value
      myString = myString.replace(/[^\d]/g, "")
      myString = myString.substring(0, 10)
      
      this.autocompleteValue = myString
      event.srcElement.value = myString

      // axios.defaults.baseURL = 'https://api.fitfood.io.vn'
      let min_week_id = 0
      if (this.load3month) {
        min_week_id = this.threeMonthsAgoWeekId
      }
      await axios
      .get('/api/v1/customerHist/?main_phone='+ myString + '&min_week_id=' + min_week_id  )
      .then(response => {
        this.resetCustInfo()
        
        let result = response.data
        this.setAutoComplete(result.phone_number_readable + ':' + result.name)
        this.custName = result.name
        this.custMainAddress = result.main_address
        this.custMainPhone = result.phone_number_readable
        this.custId = result.id
        this.transactions = result.transactions
        
        for (let i = 0; i < this.transactions.length; i++) {
          try {
            this.transactions[i]['weekStr'] = this.getWeekStr(this.transactions[i].week_id )
          } catch (error) {
            this.transactions[i]['weekStr'] = ''
          }
        }

        let traitCount = 0
        Object.keys(result.traits).forEach(key => {
          if (traitCount >10) {
            1==1          
            }
          else {
            this.traits = this.traits + '(<strong>' + Math.min(result.traits[key],99) + 'x</strong>_' + key.toLowerCase() +'); '
          }  
          
            traitCount = traitCount + 1
            
        });
        Object.keys(result.diets).forEach(key => {
            this.diets = this.diets + '(<strong>' + Math.min(result.diets[key],99) + 'x</strong>_' + key.toLowerCase() +'); '
        });
        
        this.group_address = result.customer_addresses
        
        this.notes = result.notes
        for (let i = 0; i < this.notes.length; i++) {
            this.notes[i]['is_completed_string'] = this.notes[i].is_completed == 1 ? 'done' : 'pending'
            this.notes[i]['weekStr'] = this.getWeekStr(this.notes[i].week_id)
          }

        this.notes.sort((a, b) => (a.id > b.id) ? -1 : 1)
        let ordersNotNull = result.orders.filter(order => (order.fullStr !== null)||(order.finalAmt !== 0))
        this.orders = ordersNotNull
        // console.log(this.orders)

        this.makeHist(result.orders)
        // console.log('makeHist')
        try {this.scrollEnd()} catch (error) {1==1}

        this.resetPackInfo()
        
        try {
          if (this.urlPassedWeek>0) {

            document.getElementById(this.urlPassedWeek).firstChild.click()
            this.urlPassedWeek = 0
          } else {
            document.getElementById(this.weeks[4]?.id)?.firstChild?.click()
          }
        } catch (error) {
          document.getElementById(this.weeks[4]?.id)?.firstChild?.click()
        }

        this.$store.commit('setIsLoading', false)
        this.search = ''
      })
      .catch(error => {
        
        this.resetCustInfo()
        this.resetPackInfo()
        this.makeHist([])
        this.custName = '<strong class="non-exist"> Không tồn tại </strong>'
        document.getElementById(this.weeks[4]?.id)?.firstChild?.click()
        this.$store.commit('setIsLoading', false)
      })

    },

    prepareWeek (week_id) {
      let weekObj = this.weeks.find(week => week.id === week_id)
      let history_holder = document.getElementsByClassName('history-holder')[0]
      let week_holder = document.getElementsByClassName('template-week')[0].cloneNode(true)
      week_holder.classList.remove('is-hidden')
      week_holder.classList.remove('template-week')
      week_holder.classList.add('to-destroy-week')

      let week_item = this.weeks.find(week => week.id === week_id)
      if (week_item.is_holiday === 0) {
        week_holder.getElementsByClassName('week-holder-title')[0].addEventListener('click', (event) => this.selectPack(event, false))  
      } else {
        week_holder.getElementsByClassName('week-holder-title')[0].classList.remove('is-clickable')
        week_holder.classList.add('is-holiday')
      }
      
      
      week_holder.id = weekObj.id
      let weekStr = week_holder.getElementsByClassName('weekStr')[0]
      // let weekstr_ = weekObj.start_date_id.toString().substring(4)
      weekStr.innerHTML = this.getWeekStr(weekObj.id)

      let order_template = week_holder.getElementsByClassName('template-package')[0]
      order_template.remove()
      history_holder.insertBefore(week_holder,history_holder.firstChild)
    },

    async getWeeks () {
      await axios
      .get('/api/v1/last-year-till-now/')
      .then(response => {
        let result = response.data
        this.weeks = result  
// xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

        })
      .catch(error => {
        if (error.response.status === 401) {
            // console.log('error.response.status')
            // console.log(error.response.status)
            this.$store.dispatch('LogOut')
            this.$router.push('/login')
          }
      })
    },

    scrollEnd () {
      document.getElementsByClassName('history-holder')[0].scrollLeft = 10000
    },

    makeHist (allOrders) {
      console.log('makeHist start')
      let allToDestroy = document.getElementsByClassName('to-destroy-week')
      Array.from(allToDestroy).forEach(element => {
        element.remove()
      });
      this.weeks.slice(0, 5).forEach(week => this.prepareWeek(week.id))
      
      allOrders.forEach(order => {
        let fullStr = {}
        try {
          fullStr = JSON.parse(order.fullStr)
        } catch (error) {
          fullStr = null
        }
        
        if ((fullStr === null)&&(order.finalAmt === 0)) {
          1 == 1
        } else {
          let week_holder = document.getElementById(order.week_id)
          
          if ((week_holder === null)||(week_holder === undefined)) {
            this.prepareWeek(order.week_id)
          }

          week_holder = document.getElementById(order.week_id)
          let week_packages_holder = week_holder.getElementsByClassName('week-holder-inner')[0]

        
          let order_template = document.getElementsByClassName('template-package')[0].cloneNode(true)
          order_template.classList.remove('template-package')
          order_template.getElementsByClassName('pack-id')[0].innerHTML = order.packageLocalId
          let packAlias = order.packAlias
          if (order.ycdb2 === 'Thêm phần ăn sáng dành cho gói MEAT LOVER') {
            packAlias = packAlias.replace('MEAT','MEAT-S')
          }
          order_template.getElementsByClassName('pack-alias')[0].innerHTML = packAlias
          order_template.getElementsByClassName('shipLoc')[0].innerHTML = order.shipLoc
          order_template.getElementsByClassName('idStr')[0].innerHTML = order.idStr
          order_template.getElementsByClassName('totalMeals')[0].innerHTML = order.totalMeals
          order_template.getElementsByClassName('noteDBArrText')[0].innerHTML = order.noteDBArrText
          order_template.id = order.id
          order_template.addEventListener('click', this.selectPack)
          if ((fullStr !== null)) {
            Object.keys(fullStr).forEach(day => {
            let pack_day_obj = fullStr[day]
            Object.keys(pack_day_obj).forEach(buoi => {
                if (['SA','TR','TO'].includes(buoi) === true) {
                  order_template.getElementsByClassName(this.mapDay[day])[0].getElementsByClassName(buoi)[0].innerHTML = pack_day_obj[buoi]
                } else {
                  order_template.getElementsByClassName(this.mapDay[day])[0].getElementsByClassName(buoi)[0].innerHTML = pack_day_obj[buoi].substring(0,2)
                }
              })
            });
          }
          ['SA','TR','TO','O'].forEach(day => {
            let allElements = order_template.getElementsByClassName(day)
            Array.from(allElements).forEach(element => {
              if (element.innerHTML === '') {
                element.parentElement.remove()
              }
            });
          })
        
          week_packages_holder.appendChild(order_template)         
        }
      });
      console.log('makeHist forEACH')

      let allWeeks = document.getElementsByClassName('week-holder')
      let holder = {}
      let lastWeekId = 0

      Array.from(allWeeks).forEach(week => {
        holder[week.id] = this.weeks.filter(week_ => week_.id > lastWeekId).filter(week_ => week_.id < week.id).length
        lastWeekId = week.id
      });

      for (const [key, value] of Object.entries(holder)) {

        if (value > 0) {
          let week_holder = document.getElementById(key)
          let history_holder = document.getElementsByClassName('history-holder')[0]
          let time_holder = document.getElementsByClassName('time-holder')[0].cloneNode(true)
          time_holder.classList.remove('is-hidden')
          time_holder.classList.add('to-destroy-week')

          time_holder.getElementsByClassName('numweek')[0].innerHTML = value
          history_holder.insertBefore(time_holder,week_holder)
        }
      }
      console.log('makeHist END')
    },

    async submitCreateNote () {
      
      if (document.getElementById('button-create-note').classList.contains('disabled')) {
        return
      }

      let channel = ''
      let channelActive = document.querySelector('.form-input-channel.is-active')
      Array.from(['phone','facebook','other']).forEach(element => {
        if (channelActive.classList.contains(element)) {
          channel = element
        }
      });


      let typeStr = ''
      let typeActive = document.querySelector('.form-input-type.is-active')
      Array.from(['order','payment','ship','cancel','other']).forEach(element => {
        if (typeActive.classList.contains(element)) {
          typeStr = element
        }
      });
      
      const formData = {
        customer_phone: this.custMainPhone.replaceAll('-',''),
        customer_id: this.custId,
        name: this.custName,
        channel_id: channel,
        description: document.getElementsByClassName('textarea-note')[0].value,
        type: typeStr,
        is_month_order: 0,
        last_edited_by_id: this.currentUser,
        week_id: this.selectedWeek_id,
        orderpackage_id :  ((this.selectedPackId === '') ? '' : (this.selectedPackId)) + ((this.selectedPackIdLocal === '') ? '' : ('-' + this.selectedPackIdLocal))
      }
      this.$store.commit('setIsLoading', true)
      await axios
        .post('/api/v1/create-note-and-get-by-cust/', formData)
        .then(response => {
          this.notes = response.data
          for (let i = 0; i < this.notes.length; i++) {
            this.notes[i]['is_completed_string'] = this.notes[i].is_completed == 1 ? 'done' : 'pending'
            this.notes[i]['weekStr'] = this.getWeekStr(this.notes[i].week_id)
          }
          this.notes.sort((a, b) => (a.id > b.id) ? -1 : 1)
          this.$store.commit('setIsLoading', false)
          document.getElementsByClassName('textarea-note')[0].value = ''
          document.querySelector('.form-input-channel.phone').click()
          document.querySelector('.form-input-type.order').click()
          this.evaluateCreateNote(1000)
        })
        .catch(error => {
          this.$store.commit('setIsLoading', false)
          this.evaluateCreateNote(1000)
        })
    },

    async custAddressEdit (event) {
      if (event.target.classList.contains('is-disabled')) {
        return
      }
      let custAddId = event.target.id.replace('-cust-address-item','')

      // ['makemain','deactive','activate']
      let is_main = 0
      if (event.target.classList.contains('makemain')) {
        is_main = 1
      }
      let active = 1
      if (event.target.classList.contains('deactive')) {
        active = 0
      }

      if (event.target.classList.contains('activate')) {
        active = 1
      }
      
      let formData = {
        id: custAddId,
        is_main: is_main,
        is_active: active
      }
      await axios
        .post('/api/v1/customer-address-edit/', formData)      
        .then(response => {
          this.group_address = response.data
          let main_address = this.group_address.find(address => address.is_main === 1)
          this.custMainAddress = main_address.address_detail
          this.custName = main_address.name
          this.custMainPhone = main_address.phone_number_readable

        })
    }, 

    setLocalLoad3month (event) {
      this.load3month = event.target.checked
      localStorage.setItem('load3month', event.target.checked)
    }, 

    setAutoInsertWeek (event) {
      this.autoInsertWeek = event.target.checked
      localStorage.setItem('autoInsertWeek', event.target.checked)
    },

    set3MonthsAgo () {
      var d = new Date();
      d.setMonth(d.getMonth() - 3);

      this.threeMonthsAgoWeekId = d.getUTCFullYear()*100+ (d.getUTCMonth())*4
    },

    eval_ship_dis () {
      
      let bestmatch
      if (this.selectedWard === 'na') {
        bestmatch = findBestMatch (this.selectedDistrict, this.ship_dis)
        document.getElementById('createadd_cust_ship_dis').value = bestmatch.shipDis
      } else {
        bestmatch = findBestMatch (this.selectedDistrict, this.ship_dis, this.selectedWard)
        document.getElementById('createadd_cust_ship_dis').value = bestmatch.shipDis
      }

      if (this.selectedWard_create_cust === 'na') {
        bestmatch = findBestMatch (this.selectedDistrict_create_cust, this.ship_dis)
        document.getElementById('createCust_cust_address_ship_dis').value = bestmatch.shipDis
      } else {
        bestmatch = findBestMatch (this.selectedDistrict_create_cust, this.ship_dis, this.selectedWard_create_cust)
        document.getElementById('createCust_cust_address_ship_dis').value = bestmatch.shipDis
      }
      
      // document.getElementById('createadd_cust_ship_dis').value = bestmatch.shipDis
    },

    // Strip Vietnamese diacritics + lowercase, so "go vap" matches "Gò Vấp".
    removeVnAccents (str) {
      return String(str == null ? '' : str)
        .replace(/đ/g, 'd').replace(/Đ/g, 'D')
        .normalize('NFD').replace(/[̀-ͯ]/g, '')
        .toLowerCase().trim()
    },

    // Accent-insensitive filter for the New Ward v-autocomplete.
    newWardFilter (value, query) {
      return this.removeVnAccents(value).includes(this.removeVnAccents(query))
    },

    // ship_dis is derived from the selected new ward rather than picked: the same
    // no-accent string with the leading "phuong "/"xa " dropped.
    //   'phuong an dong'  -> 'an dong'
    //   'xa binh chanh'   -> 'binh chanh'
    // Accented spellings are tolerated in case the value ever arrives that way.
    shipDisFromNewWard (newWardStr) {
      const s = String(newWardStr == null ? '' : newWardStr).trim()
      if (!s || s === 'na') return ''
      return s.replace(/^(phường|phuong|xã|xa)\s+/i, '')
    },

    // A v-autocomplete copies the model title into its internal `search` text only
    // when it gains focus. Tabbing out of the address box skips the disabled
    // District/Ward/ShipLoc selects and lands on New Ward *before* /clean_address
    // answers, so the later v-model write never reaches the visible input. Push the
    // title in ourselves, but never over something the user is actively typing.
    syncNewWardSearch (refName, value) {
      const cmp = this.$refs[refName]
      if (!cmp || !cmp.isFocused) return
      if (cmp.search && !cmp.isPristine) return

      const entry = this.newWardByNoAccent[value]
      cmp.search = (entry && entry.name) ? entry.name : ''
      // Writing `search` opens the menu and marks the field dirty on the next flush;
      // undo both so the field looks exactly as if it had been focused after the fill.
      this.$nextTick(() => {
        cmp.menu = false
        cmp.isPristine = true
      })
    },

    // New ward drives district + shipLoc. Old ward stays whatever the auto-clean set,
    // but is blanked if it doesn't belong to the chosen new ward.
    onNewWardChange () {
      const entry = this.newWardByNoAccent[this.selectedNewWard] || null
      this.selectedDistrict = (entry && entry.district_str) ? entry.district_str : 'na'
      this.selectedShipDis = (entry && entry.ship_dis) ? entry.ship_dis : 'na'
      if (this.selectedWard && this.selectedWard !== 'na') {
        if (this.ward_to_new_ward[this.selectedWard] !== this.selectedNewWard) {
          this.selectedWard = 'na'
        }
      }
    },

    onNewWardChange_create_cust () {
      const entry = this.newWardByNoAccent[this.selectedNewWard_create_cust] || null
      this.selectedDistrict_create_cust = (entry && entry.district_str) ? entry.district_str : 'na'
      this.selectedShipDis_create_cust = (entry && entry.ship_dis) ? entry.ship_dis : 'na'
      if (this.selectedWard_create_cust && this.selectedWard_create_cust !== 'na') {
        if (this.ward_to_new_ward[this.selectedWard_create_cust] !== this.selectedNewWard_create_cust) {
          this.selectedWard_create_cust = 'na'
        }
      }
    },

    async copyCustInfo(event) {
      const icon = event.currentTarget;
      icon.style.color = "green";
      setTimeout(() => { icon.style.color = ""; }, 500);

      const html = `<b>Name:</b> ${this.custName}<br><b>Main Address:</b> ${this.custMainAddress}<br><b>Main Phone:</b> ${this.custMainPhone}`;
      const text = [`Name: ${this.custName}`, `Address: ${this.custMainAddress}`, `Phone: ${this.custMainPhone}`].join('\n');

      try {
        if (window.ClipboardItem && navigator.clipboard?.write) {
          const item = new ClipboardItem({
            'text/html': new Blob([html], { type: 'text/html' }),
            'text/plain': new Blob([text], { type: 'text/plain' }),
          });
          await navigator.clipboard.write([item]);
          return;
        }
      } catch (err) {
        // fall through to next strategy

      }
    }

  },
  
  async beforeMount() {
    try { this.load3month = JSON.parse(localStorage.getItem('load3month'))  
    } catch (error) {
      this.load3month = false
    }
    try { this.autoInsertWeek = JSON.parse(localStorage.getItem('autoInsertWeek'))  
    } catch (error) {
      this.autoInsertWeek = false
    }
    
    this.set3MonthsAgo()
    
  },

  async mounted () {
    document.title = 'Order History'
    this.currentUser = localStorage.getItem('user')
    let params = (new URL(document.location)).searchParams;

    axios
      .get('/api/v1/get-pack-config/')
      .then(response => {

        try {this.ship_dis = response.data['ship_dis']} catch (error) {
          this.ship_dis = {}
        }

        try {this.districts = response.data['districts']} catch (error) {
          this.districts = []
          // districts is a list
        }

        try {this.old_wards = response.data['old_wards']} catch (error) {
          this.old_wards = {}
        }

        try { this.new_wards = response.data['new_wards'] } catch (error) {
          this.new_wards = {}
        }

        try { this.ward_to_new_ward = response.data['ward_to_new_ward'] } catch (error) {
          this.ward_to_new_ward = {}
        }


      })

    await this.getWeeks();

    try {
      let name = params.get("q");
      let week_chonsen = params.get("week_id");
      // console.log(name)
      if (name === null) {
        name = ''
      }
      this.urlPassedWeek = week_chonsen
    
      this.autocompleteValue = name
      this.formPhoneChange({srcElement: {value: name }});
      // console.log('week_chonsen')  
    } catch (error) {
      1==1
      // this.formPhoneChange({srcElement: {value: 0}});
    }


    
    document.addEventListener('click', this.handleClick)
    
    await axios
    .get('/api/v1/cache-cust/')
    .then(response => {
      this.autocompleteSuggestions = response.data
      // console.log('this.autocompleteSuggestions')
      // console.log(this.autocompleteSuggestions)
    })
    .catch(error => {
      // console.log(error)
    });

    this.setAutoComplete('init')
    
    
    
  },

  computed: {
    quickWeekStr () {
      return this.getWeekStr(this.selectedWeek_id)
    },

    hasValueCustInfo () {
      let resulte = ((this.autocompleteValue !== '') && (this.autocompleteValue !== null))
      return resulte
    },
    group_address_filtered () {
      if (this.addressShowAll) {
        // return this.group_address.filter(address => address.is_main !== 1)
        return this.group_address
      } else {
        return this.group_address.filter(address => address.is_active === 1)
        // return this.group_address.filter(address => address.is_active === 1).filter(address => address.is_main !== 1)
      }
      
    },
    isPlaningCS : function(){
        return this.$store.getters.isPlaning
    },

    // new_wards is keyed by accented name; the selects store name_no_accent.
    // Build a lookup keyed by name_no_accent so a selection resolves to its
    // related district_str / ship_dis.
    newWardByNoAccent () {
      const map = {}
      const src = this.new_wards || {}
      for (const key in src) {
        const item = src[key]
        if (item && item.name_no_accent) {
          map[item.name_no_accent] = item
        }
      }
      return map
    },

    // Options for the New Ward typeahead (v-autocomplete): accented label,
    // name_no_accent value. Sorted by label.
    newWardOptions () {
      const src = this.new_wards || {}
      const arr = []
      for (const key in src) {
        const item = src[key]
        if (item && item.name_no_accent) {
          arr.push({ title: item.name, value: item.name_no_accent })
        }
      }
      arr.sort((a, b) => a.title.localeCompare(b.title))
      return arr
    },

    wards_selected_district () {
      try {
        let result =  this.old_wards[this.selectedDistrict] || [];

        
        // this part only sorts the wards by their numbers
        return result.sort((a, b) => {
          const getWardNumber = (s) => {
            const match = s.match(/phuong\s+(\d+)/i);
            const wardNumber = match ? parseInt(match[1], 10) : Number.POSITIVE_INFINITY;
            return wardNumber;
          };

          const aNum = getWardNumber(a);
          const bNum = getWardNumber(b);

          if (aNum !== bNum) return aNum - bNum;
          return a.localeCompare(b, 'vi'); // fallback for non-numeric names
        });
      } catch (error) {
        return []
      }
      
    },

    wards_selected_district_create_cust () {
      try {
        let result =  this.old_wards[this.selectedDistrict_create_cust] || [];
        // this part only sorts the wards by their numbers
        return result.sort((a, b) => {
          const getWardNumber = (s) => {
            const match = s.match(/phuong\s+(\d+)/i);
            const wardNumber = match ? parseInt(match[1], 10) : Number.POSITIVE_INFINITY;
            return wardNumber;
          };

          const aNum = getWardNumber(a);
          const bNum = getWardNumber(b);

          if (aNum !== bNum) return aNum - bNum;
          return a.localeCompare(b, 'vi'); // fallback for non-numeric names
        });
      } catch (error) {
        return []
      }

      },

  },
  
  
  updated () {
    
  },
}

</script>

<style scoped>
.cust_focus_info_wrapper {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex: 1 1 0;
  min-height: 0;
}

.group_address {
  flex: 1 1 0;
  min-height: 0;
  overflow: hidden;
}

.min-h-0 {
  min-height: 0;
}

.side-panel {
  min-height: 0;
  overflow: hidden;
}

tr:nth-child(even) {
  background-color: #f0f0f0;
}

.mon {
  border-left: 1px solid black;
}

.mon, .tue, .wed, .thu, .fri {
  border-right: 1px solid black;
  font-size: large;
  flex-grow: 1;
  background-color: white;
}

.orderpacks-holder.selected > .orderpack-detail > .orderpack-detail-contents > .mon {
  border-left: 3px solid black;
}

.orderpacks-holder.selected > .orderpack-detail > .orderpack-detail-contents > .fri {
  border-right: 3px solid black;
}

.orderpack-detail {
  margin-top: 0.5em;
}

.orderpack-detail-contents {
  padding: 0 0.5em;
}

.orderpack-detail-title {
  padding: 0 0.5em;
}

.orderpack-detail-title-line {
  background-color: #f18973;
  padding: 0 0.5em;
  border-top-right-radius: 1em;
  border: 1px solid black;
  border-bottom: 0 !important;
}

.orderpacks-holder.selected > .orderpack-detail > div.orderpack-detail-title > div.orderpack-detail-title-line {
  background-color: hsl(44, 100%, 77%) !important;
  border: 3px solid black;
}

.orderpack-detail-title-after {
  padding: 0 0.5em;
}

.orderpack-detail-title-after-line {
  background-color: #f7cac9;
  padding: 0 0.5em;
  border-bottom-left-radius: 1em;
  border: 1px solid black;
  border-top: 0 !important;
}

.orderpacks-holder.selected > .orderpack-detail > .orderpack-detail-title-after > .orderpack-detail-title-after-line {
  border: 3px solid black;
}

.orderpack-detail-title-after-line-1 {
  padding: 0 0.5em;
  background-color: white;
  border: 1px solid black;
  border-top: 0 !important;
  border-bottom: 0 !important;
}

.orderpacks-holder.selected > .orderpack-detail > .orderpack-detail-title-after > .orderpack-detail-title-after-line-1 {
  border: 3px solid black;
}

/* shorthand first, then specific overrides so !important wins */
.orderpack-detail-contents div {
  padding: 0.5em;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.history-holder {
  display: flex;
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  min-height: 0;
}

.history-holder::before {
  content: "";
  flex: 0 0 20vw;
  visibility: hidden;
}

.history-holder::-webkit-scrollbar {
  height: 1.25em;
}

.week-holder-inner {
  flex: 1 1 0;
  min-height: 0;
  overflow-y: auto;
  padding-bottom: 1em;
  overflow-x: hidden;
}

.week-holder {
  display: flex;
  flex-direction: column;
  margin-right: 0.5em;
  border: 1px solid black;
  border-bottom-left-radius: 1vw;
  border-top-right-radius: 1vw;
}

.week-holder.time-holder {
  background-color: #cccccc;
}

.week-holder.selected {
  border: 2px solid black;
  background-color: #ebbfbf;
}

.week-holder-title {
  border-top-right-radius: 1vw;
  padding: 0 0.5em;
}

.custText-preText {
  border: 1px solid rgb(138, 138, 138);
  border-right: 0 !important;
  padding: 0.2em 0.2em 0.2em 0.3em;
  border-top-left-radius: 0.5em;
  border-bottom-left-radius: 0.5em;
}

.custPrice-preText {
  border-right: 0 !important;
  padding: 0.1em;
  border-top-left-radius: 0.5em;
  border-bottom-left-radius: 0.5em;
  display: flex;
  flex-grow: 2;
  min-width: 75%;
  justify-content: center;
}

.order-info-item-line {
  margin-bottom: 0.2em;
}

.custText {
  padding: 0.2em 1em 0.2em 0.5em;
  background-color: #c4cebb;
  border-left: 0 !important;
  width: 100%;
  border-top-right-radius: 0.5em;
  border-bottom-right-radius: 0.5em;
}

.custPrice {
  padding: 0.1em 1em 0.1em 0.5em;
  background-color: #c4cebb;
  border-left: 0 !important;
  width: 100%;
  border-top-right-radius: 0.5em;
  border-bottom-right-radius: 0.5em;
  flex-grow: 1;
  text-align: right;
}

.order-info-part-1 {
  padding-right: 1em;
  overflow-y: auto;
  flex: 1 1 0;
  min-height: 0;
}

.order-info-invoice {
  padding-right: 1em;
  overflow-y: auto;
  flex: 1 1 0;
  min-height: 0;
}

.line-break,
.line-break-2 {
  border-bottom: 2px solid black;
}

.detail-holder-info {
  max-width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 0;
  flex: 1 1 0;
}

.side-order-name {
  padding-right: 2px;
}

.price-holder {
  flex: 1 1 0;
  min-height: 0;
  overflow-y: auto;
}

.name-cust-price {
  border-bottom: 2px solid black;
  border-radius: 0 !important;
}

.control-item {
  background-color: hsl(44, 24%, 66%);
  border: 1px solid rgb(134, 134, 134);
}

.control-item.is-active {
  background-color: hsl(44, 100%, 77%) !important;
  border: 1px solid black;
  border-bottom: 0 !important;
  font-weight: bold;
  border-top-right-radius: 0.5em;
}

#customerBalance {
  border-top-right-radius: 0.5em;
}

.nowrap {
  white-space: nowrap;
}

/* merged from two separate .pack-table-title blocks */
.pack-table-title {
  width: 8%;
  border-right: 2px solid black;
}

.pack-table-details {
  width: 92%;
}

.pack-table-cell {
  flex-grow: 1;
  flex-basis: 0;
  padding-left: 0.2em;
}

.pack-table-cell-2 {
  flex-grow: 2;
  flex-basis: 0;
  text-align: right;
  padding-right: 0.5em;
}

.details-with-ship-holder {
  flex: 1 1 0;
  min-height: 0;
  overflow-y: auto;
}

.pack-table-tbody {
  border: 2px solid black;
  border-collapse: collapse;
  margin: 0.2em 0;
}

.pack-table-details-title {
  background-color: #aaaaaa;
  border-bottom: 2px solid black;
}

.pack-table-TR > .pack-table-cell-2,
.pack-table-O > .pack-table-cell-2,
.pack-table-deliverTimeslot > .pack-table-cell-2,
.pack-table-address > .pack-table-cell-2 {
  background-color: #d8d8d8;
}

.pack-table-SA, .pack-table-TR, .pack-table-TO,
.pack-table-shipDis, .pack-table-shipper, .pack-table-deliverTimeslot {
  border-bottom: 1px solid black;
}

.pack-table-O {
  border-bottom: 2px solid black;
}

div.pack-table-tbody.is-active > div > .pack-table-details-title {
  background-color: hsl(44, 100%, 77%) !important;
}

.orderList-control-class,
.customerBalance-control-class,
.info-control-class,
.details-control-class {
  display: none !important;
}

.orderList-control-class.is-active,
.customerBalance-control-class.is-active,
.info-control-class.is-active,
.details-control-class.is-active {
  display: flex !important;
  flex: 1 1 0;
  min-height: 0;
  overflow: hidden;
  max-width: 100%;
}

tr.is-active {
  background-color: hsl(44, 100%, 77%);
}

#wrapper {
  overflow-y: hidden;
  height: 100vh !important;
}

#app {
  overflow-y: hidden;
  height: 100vh !important;
}

#shadowLL {
  overflow-y: hidden;
  height: 100vh !important;
}

.section {
  overflow-y: hidden;
  height: 95vh !important;
}

.no-flow-y {
  overflow-y: hidden;
  height: 100%;
  min-height: 0;
}

.container {
  overflow-y: hidden;
  height: 100% !important;
}

.note-holder {
  margin-left: 0.5em;
  min-height: 0;
}

.textarea-note {
  border-radius: 0;
  border-right: 1px solid rgb(138, 138, 138);
  border-left: 1px solid rgb(138, 138, 138);
}

.top-addon {
  border: 1px solid rgb(138, 138, 138);
  border-top-right-radius: 1em;
  border-top-left-radius: 1em;
  border-bottom: 0 !important;
}

.bottom-addon {
  border: 1px solid rgb(138, 138, 138);
  border-top: 0 !important;
  border-bottom-right-radius: 1em;
  border-bottom-left-radius: 1em;
  font-weight: bold;
}

.bottom-addon.disabled {
  color: rgb(161, 161, 161);
}

.form-input.is-active {
  color: #f18973;
}

.note-holder-scroll {
  overflow-y: auto;
}

td, th {
  font-size: 1rem;
}

/* merged two .disabled rules + hover */
#button-create-note.disabled {
  background-color: hsl(44, 24%, 66%) !important;
  color: rgb(53, 53, 53);
  cursor: no-drop !important;
}

#button-create-note {
  background-color: hsl(44, 100%, 77%) !important;
}

.form-input-channel {
  font-size: 1.05em;
}

.non-exist {
  color: red;
}

.totalBeforeDiscount-pack-price,
.finalAmt-pack-price {
  font-weight: bold;
}

.week_str-pack-price {
  padding-left: 2px;
}

.transactions-list.is-active {
  background-color: hsl(44, 100%, 77%) !important;
}

.autocomplete-results-holder {
  position: absolute;
  z-index: 1000;
  max-height: 25vh !important;
  background-color: white;
  width: 100%;
  overflow-y: auto;
  border: 1px solid rgb(179, 179, 179);
  border-bottom-left-radius: 0.5em;
  border-bottom-right-radius: 0.5em;
}

.autocomplete-result {
  list-style: none;
  text-align: left;
  cursor: pointer;
  overflow-wrap: break-word;
  padding-bottom: 0.5em;
}

/* merged :hover and .is-active — same style */
.autocomplete-result:hover,
.autocomplete-result.is-active {
  background-color: hsl(44, 88%, 91%);
}

.custinfo_cust_phone-remove {
  position: absolute;
  z-index: 1000;
  padding-left: 1em;
  padding-top: 0.8em;
  cursor: pointer;
  color: red;
}

#custinfo_cust_phone {
  padding-left: 2.5em;
}

.custAdd-control.is-clickable:hover {
  color: red;
}

.custAdd-control.is-disabled {
  color: rgb(161, 161, 161);
}

.is-holiday {
  background-color: #cccccc;
}

.form-input-type-holder {
  border-left: 1px solid #aaaaaa;
  border-right: 1px solid #aaaaaa;
}

input[type=checkbox] {
  -webkit-transform: scale(1.25);
  transform: scale(1.25);
}

.group_main_info {
  overflow-y: auto;
  padding: 0;
  margin: 0.5em 0;
  flex: 0 1 auto;
}

.table-transaction-height,
.table-main-order-list-height {
  height: 100%;
}

.table-address-height {
  height: 100%;
}

.table-note-height {
  height: 100%;
}

#table-main-note td {
  font-size: 1.1rem;
}

.current-week-notes {
  background-color: #f7cac9 !important;
}

@media (-webkit-min-device-pixel-ratio: 1.15) {
  .form-input-type-holder.is-size-5,
  .form-input-channel-holder.is-size-5,
  .week_id-note-week_str {
    font-size: 1em !important;
  }

  .form-input-type-holder {
    border: 0 !important;
  }

  .table-transaction-height,
  .table-main-order-list-height {
    height: 100% !important;
  }

  .table-address-height {
    height: 100% !important;
  }

  .table-note-height {
    height: 100% !important;
  }

  /* merged three identical td font-size rules */
  #table-main-order-list td,
  #table-transactions td,
  #table-main-note td {
    font-size: 1rem !important;
  }
}
</style>

<style>
#table-main-note thead {
  display: none !important;
}

#table-group-address thead {
  display: none;
}

#table-group-address td {
  font-size: 1.1rem;
}

#table-group-address tr {
  height: auto !important;
}

/* merged — same font-size */
#table-main-order-list td,
#table-transactions td {
  font-size: 1.1rem;
}

#table-main-order-list thead > tr > th:nth-child(6) > div {
  text-align: right;
  width: 100%;
  flex-direction: row;
  align-content: end;
  flex-wrap: wrap;
}

/* merged — identical layout for th span alignment */
#table-main-order-list thead > tr > th:nth-child(6) > div > span,
#table-transactions thead > tr > th:nth-child(4) > div > span,
#table-transactions thead > tr > th:nth-child(5) > div > span,
#table-transactions thead > tr > th:nth-child(6) > div > span {
  width: 100%;
  text-align: right;
  flex-grow: 1;
  flex-basis: 0;
  padding-right: 0.5em;
}

#table-transactions thead > tr > th:nth-child(5) > div {
  text-align: right;
  width: 100%;
  flex-direction: row;
  align-content: end;
  flex-wrap: wrap;
}

table thead {
  font-size: 1rem;
}
</style>